import {
  TextField,
  Box,
  Checkbox,
  FormLabel,
  useTheme,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Breadcrumbs,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
} from "@mui/material";
import dayjs from "dayjs";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import axios from "axios";
import store from "../../..";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
import {
  postData,
  sprintGetData,
  sprintprojectplanGetData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { tokens } from "../../../Theme";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowModes,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import { Formik, Field } from "formik";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Mode } from "@mui/icons-material";
import TimeSheetPDF from "../../reports/TimeSheetPdf";
import SprintPDF from "../../reports/Sprintpdf";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ErrorMsgData from "../../Security/validationMsg.json";
import * as Yup from "yup";
import { getConfig } from "../../../config";
import sprintExcel from "../../reports/sprintExcel";
import { FaFileExcel } from "react-icons/fa";


const EditSprint = (empId, appId) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();

  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  const getLoading = useSelector((state) => state.formApi.sprintloading);
  const SprintGEtdata = useSelector((state) => state.formApi.sprintget) || {};
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);

  const sprintPPgetloading = useSelector(
    (state) => state.formApi.sprintloading
  );
  const YearFlag = sessionStorage.getItem("YearFlag");
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
  // const CompanyAutoCode = "N";
  console.log(CompanyAutoCode, "CompanyAutoCode");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const CompanyID = sessionStorage.getItem("companyId");
  const [files, setFiles] = useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const EMPID = sessionStorage.getItem("EmpId");
  const location = useLocation();
  const state = location.state || {};
  const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);

        let schemaFields = {};

        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Routinetask.code);
        }

        const schema = Yup.object().shape(schemaFields);
        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [CompanyAutoCode]);

  useEffect(() => {
    GetSprintData();
    var url = store.getState().globalurl.empGetAttachmentUrl;
    axios
      .get(url, {
        params: {
          empId: EMPID,
          appId: recID,
        },
      })
      .then((response) => {
        setFiles(response.data);
      })
      .catch((err) => {
        setError("Failed to fetch attachments.");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [location.key]);

  async function GetSprintData() {
    dispatch(sprintGetData({ SprintHeaderID: recID })).then((res) => {
      if (res.payload.Status == "Y") {
        const resData = res.payload.Data.detailData.map((value) => {
          return {
            ...value,
            ScheduledTo: {
              RecordID: value.ScheduledTo,
              Name: value.EmployeeName,
            },
          };
        });
        setRows(resData);
      } else {
        setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
      }
    });
  }

  // *************** INITIALVALUE  *************** //
  const [rowModesModel, setRowModesModel] = useState({});
  const [funMode, setFunMode] = useState(mode);
  const [open, setOpen] = useState(false);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState(null);
  const [selectedScheduledToOptions, setSelectedScheduledToOptions] =
    useState(null);

  const [rows, setRows] = useState([]);

  const InitialValue = {
    code: SprintGEtdata.Code,
    name: SprintGEtdata.Name,
    Milestone: SprintGEtdata.MilestoneID
      ? {
        RecordID: SprintGEtdata.MilestoneID,
        Name: SprintGEtdata.MilestoneName,
      }
      : "",
    OperationStage: SprintGEtdata.OperationStageID
      ? {
        RecordID: SprintGEtdata.OperationStageID,
        Name: SprintGEtdata.OperationName,
      }
      : null,
    Activities: SprintGEtdata.ActivitiesID
      ? {
        RecordID: SprintGEtdata.ActivitiesID,
        Name: SprintGEtdata.ActivitiesName,
      }
      : null,
    fromdate: SprintGEtdata.FromDate,
    todate: SprintGEtdata.ToDate,
    checkbox: SprintGEtdata.BackLog === "Y" ? true : false,
  };

  const handleApply = async (values) => {
    const data = await dispatch(
      sprintprojectplanGetData({
        ActivitiesID: values.Activities ? values.Activities.RecordID : 0,
        //ActivitiesID:"43",
        FromDate: values.fromdate,
        ToDate: values.todate,
        BackLog: values.checkbox === true ? "Y" : "N",
      })
    );
    console.log(" ~ handleApply ~ data:", data);

    if (data.payload.Status === "Y") {
      const resData = data.payload.Data.map((row) => ({
        ...row,
        ScheduledTo: row.ScheduledTo
          ? {
            EmployeeID: row.ScheduledTo,
            Name: row.EmployeeName,
          }
          : null,
      }));

      setRows(resData);
    } else {
      setRows([]);
    }

    //    setRows(data.payload.Data);
    //    setRows(resData);



    // } else {
    //   setRows([]);
    // }
  };

  const handleSave = (id, params, action) => () => {
    const rowToSave = params?.row;
    if (!rowToSave) {
      toast.error("Row not found.");
      return;
    }

    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.View },
    }));
  };

  const handleEditClick = (id) => () => {
    setFunMode("E");
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit },
    }));
  };

  const handleDeleteClick = (id) => async () => {
    console.log(" ~ handleDeleteClick ~ id:", id);
    try {
      setRows((prev) => prev.filter((row) => row.RecordID !== id));

      console.log(" ~ handleDeleteClick ~ rows:", rows);
    } catch (error) {
      console.error("Error deleting row:", error);
      toast.error("Error occurred during delete.");
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
    setSelectedRoleOptions(null);
    setSelectedScheduledToOptions(null);
  };

  const handleSaveButtonClick = async (values, action) => {
    var isCheck = "N";
    if (values.checkbox == true) {
      isCheck = "Y";
    }

    console.log(" ~ Details:rows.map ~ rows:", rows);
    const idata = {
      RecordID: recID,
      Code: values.code,
      Name: values.name,
      MilestoneID: values.Milestone ? values.Milestone.RecordID : 0,
      MilestoneName: values.Milestone ? values.Milestone.Name : 0,
      OperationStageID: values.OperationStage
        ? values.OperationStage.RecordID
        : 0,
      OperationStageName: values.OperationStage
        ? values.OperationStage.Name
        : 0,
      ActivitiesID: values.Activities ? values.Activities.RecordID : 0,
      ActivitiesName: values.Activities ? values.Activities.Name : 0,
      FromDate: values.fromdate,
      ToDate: values.todate,
      ProjectID: params.filtertype,
      LoginUser: EMPID,

      BackLog: values.checkbox === true ? "Y" : "N",
      Details:
        rows.filter(row => row.ScheduledTo != null).map((row, index) => ({
          //RecordID: row.RecordID || "",
          Task: row.Task || "",
          RoleID: row.RoleID || "",
          Effort: row.Effort || "",
          ProjectPlanDate: row.ProjectPlanDate || "",
          ScheduledDate: row.ScheduledDate || "",
          CompletedDate: row.CompletedDate || "",
          ScheduledTo: row.ScheduledTo?.EmployeeID || "0",
          TaskDetailID: row.RecordID || "",
          // TaskDetailID: row.TaskDetailID || "",
          Status: row.Status || "SH",
          Comments: row.Comments || "",
        })) || [],
    };

    try {
      const response = await dispatch(
        postData({
          accessID: "TR262",
          // action : funMode,
          action: mode === "A" ? "insert" : "update",
          idata: idata,
        })
      );
      //mail Should sent to Employee

      // Check response status for success
      if (response.payload.Status === "Y") {
        //  dispatch(
        //                 requestMail({
        //                   EmployeeID: EMPID,
        //                   Type: "DT",
        //                   RecordID: recID,
        //                 })
        //               );

        toast.success(response.payload.Msg);
        // navigate
        setRows((prev) =>
          prev.map((row) => ({
            ...row,
            isNew: false,
            isUpdated: false,
          }))
        );
      } else {
        toast.error(response.payload.Msg || response.payload.Data);
      }
    } catch (error) {
      console.error("Error saving rows:", error);
      toast.error("Error occurred during save.");
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };

  const [rowCount, setRowCount] = useState(0);
  function Custombar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Sprint Task</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
      </GridToolbarContainer>
    );
  }

  const processRowUpdate = (newRow, oldRow) => {
    const isNew = !oldRow?.RecordID;
    const updatedRow = { ...newRow, isNew };

    setRows((prev) => {
      const index = prev.findIndex(
        (row) => row.RecordID === updatedRow.RecordID
      );
      if (index !== -1) {
        const newData = [...prev];
        newData[index] = updatedRow;
        return newData;
      }
      return [...prev, updatedRow];
    });
    return updatedRow;
  };

  function EditAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (newValue) => {
      console.log(" ~ handleChange ~ newValue:", newValue);
      if (!newValue) return;

      setEmployee(newValue);
      await api.setEditCellValue({
        id,
        field: "ScheduledTo",
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };
    const [Employee, setEmployee] = useState(row.ScheduledTo ? row.ScheduledTo : null);
    return (
      <SprintEmpAutocomplete
        name="ScheduledTo"
        label="ScheduledTo"
        id="ScheduledTo"
        value={Employee}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2109","ScreenName":"Scheduled To","Filter":"DesignationID='${row.DesignationsID
          }' AND ProjectID='${state.projectID || params.filtertype}'","Any":""}}`}
      // url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2106","ScreenName":"Scheduled To","Filter":"ERank='${row.Rank}' AND parentID='${CompanyID}'","Any":""}}`}
      />
    );
  }

  // function EditDateCell(props) {
  //   const { id, field, value, api } = props;

  //   const handleChange = (event) => {
  //     const newValue = event.target.value;
  //     api.setEditCellValue({ id, field, value: newValue });
  //   };

  //   return (
  //     <TextField
  //       type="date"
  //       fullWidth
  //       size="small"
  //       value={value ? new Date(value).toISOString().split("T")[0] : ""}
  //       onChange={handleChange}
  //       InputLabelProps={{ shrink: true }}
  //     />
  //   );
  // }
  // const ApprovedData = safeAttendanceData.filter(
  //   (row) => row.Status === "Approved"
  // );
  function EditDateCell(props) {
    const { id, field, value, api } = props;

    const formatToInputDate = (val) => {
      if (!val) return "";

      const date = new Date(val);
      if (isNaN(date.getTime())) return "";   // prevent invalid time error

      return date.toISOString().split("T")[0];
    };

    const handleChange = (event) => {
      const newValue = event.target.value;
      api.setEditCellValue({ id, field, value: newValue });
    };

    return (
      <TextField
        type="date"
        fullWidth
        size="small"
        value={formatToInputDate(value)}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    );
  }
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";

    const [year, month, day] = dateStr.split("-");
    if (!year || !month || !day) return "";

    return `${day}-${month}-${year}`;
  }

  const Sprintcolumns = [
    // { field: "SLNO", headerName: "SL#", width: 70 },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "Task",
      field: "Task",
      width: "250",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Role",
      field: "DesignationsName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Effort",
      field: "Effort",
      width: "100",
      align: "right",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Project Plan Date",
      field: "ProjectPlanDate",
      type: "date",
      width: "150",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
      // renderCell: (params) => {
      //   return formatDateToDDMMYYYY(params.value); // show only the name
      // },
    },
    {
      headerName: "Scheduled Date",
      field: "ScheduledDate",
      width: "100",
      hide: false,
      editable: true,
      // renderCell: (params) => {
      //   return formatDateToDDMMYYYY(params.value); // show only the name
      // },
      renderEditCell: (params) => {
        return <EditDateCell {...params} />;
      },
    },
    {
      field: "ScheduledTo",
      headerName: (
        <span>
          Scheduled To <span style={{ color: "red" }}>*</span>
        </span>
      ),
      width: 150,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditAutocompleteCell {...params} />;
      },
    },
    //  {
    //   field: "OccupiedHours",
    //   headerName: (
    //     <span>
    //       Occupied Hrs <span style={{ color: "red" }}>*</span>
    //     </span>
    //   ),
    //   width: 150,
    //   align: "left",
    //   headerAlign: "center",
    //   hide: false,
    //   editable: true,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return params.value?.Name || ""; // show only the name
    //   },
    //   renderEditCell: (params) => {
    //     return <EditAutocompleteCell {...params} />;
    //   },
    // },
    ...(mode === "E"
      ? [
        {
          headerName: "Completed Date",
          field: "CompletedDate",
          type: "date",
          width: "150",
          hide: false,
          editable: false,
        },
      ]
      : []),
    {
      headerName: "Comments",
      field: "Comments",
      width: "220",
      hide: false,
      editable: true,
    },
    {
      headerName: "Status",
      field: "Status",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "#009688" }}
              onClick={handleSave(params.id, params, funMode)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={() => {
                setRowModesModel((prev) => ({
                  ...prev,
                  [params.id]: { mode: GridRowModes.View },
                }));
                setSelectedRoleOptions(null);
              }}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon style={{ color: "#3498db" }} />}
            label="Edit"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon style={{ color: "#e74c3c" }} />}
            label="Delete"
            onClick={handleDeleteClick(params.id, params, "harddelete")}
            color="inherit"
          />,
        ];
      },
    },
  ];

  // if (mode === "E") {
  //   Sprintcolumns.splice(7, 0, {
  //     headerName: "Completed Date",
  //     field: "CompletedDate",
  //     type: "date",
  //     width: 150,
  //     hide: false,
  //     editable: false,
  //   });
  // }

  async function fileUpload(file, EMPID, action, id, purpose) {
    console.log(" ~ fileUpload ~ file:", file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", EMPID);
    formData.append("appId", recID);
    formData.append("type", "SP");
    formData.append("source", "Sprint");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    console.log(" ~ fileUpload ~ formData:", formData);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }

    console.log(" ~ fileUpload ~ respose:", respose);
  }

  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={1}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              {/* <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => {
                  navigate("/Apps/TR133/Project");
                }}
              >
                {`Project(${state.projectName})`}
              </Typography> */}

              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", marginLeft: "10px" }}
                onClick={() => navigate(-1)}
              >
                Sprint
              </Typography>
            </Breadcrumbs>
          </Box>

          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        {mode === "IM" && (
          <Box
            display="flex"
            padding={1}
            justifyContent="flex-end"
            mt="2px"
            gridColumn="span 4"
            gap={2}
            marginBottom={-5}
          >
            <IconButton
              onClick={() => setShowImage((prev) => !prev)}
              sx={{ padding: "12px" }}
            >
              <ArrowDownwardIcon sx={{ color: "blue", marginBottom: "8px" }} />
            </IconButton>
          </Box>
        )}

        <Formik
          initialValues={InitialValue}
          onSubmit={(values, setSubmitting) => {
            setTimeout(() => {
              handleApply(values);
            }, 100);
          }}
          enableReinitialize={true}
          validationSchema={validationSchema}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap={formGap}
                padding={1}
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                // gap="30px"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 2",
                  },
                }}
              >
                {CompanyAutoCode == "Y" ? (
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label="Code"
                    variant="standard"
                    placeholder="Auto"
                    focused
                    //required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    InputProps={{ readOnly: true }}
                  />
                ) : (
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={
                      <>
                        Code
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    autoFocus
                  />
                )}

                <TextField
                  name="name"
                  type="text"
                  id="name"
                  label="Description"
                  variant="standard"
                  focused
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                  autoFocus={CompanyAutoCode == "Y"}
                />
                {!showImage ? (
                  <React.Fragment>
                    <TextField
                      name="fromdate"
                      type="date"
                      id="fromdate"
                      label="From Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.fromdate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.fromdate && !!errors.fromdate}
                      helperText={touched.fromdate && errors.fromdate}
                      sx={{ background: "" }}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      name="todate"
                      type="date"
                      id="todate"
                      label="To Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.todate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.todate && !!errors.todate}
                      helperText={touched.todate && errors.todate}
                      sx={{ background: "" }}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        inputProps: {
                          min: values.fromdate || undefined,
                          max: values.fromdate
                            ? dayjs(values.fromdate)
                              .add(6, "day")
                              .format("YYYY-MM-DD")
                            : undefined,
                        },
                      }}
                    />
                    <Productautocomplete
                      sx={{ marginTop: "7px" }}
                      name="Milestone"
                      label="Milestone"
                      variant="outlined"
                      id="Milestone"
                      value={values.Milestone}
                      getOptionLabel={(option) => option?.Name || ""}
                      onChange={(newValue) => {
                        setFieldValue("Milestone", newValue);
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"ParentID=${params.filtertype} AND CompanyID=${CompanyID}","Any":""}}`}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"ParentID=${params.filtertype}","Any":""}}`}
                    />
                    <Productautocomplete
                      sx={{ marginTop: "7px" }}
                      name="OperationStage"
                      label="Operation Stage"
                      variant="outlined"
                      id="OperationStage"
                      value={values.OperationStage}
                      onChange={(newValue) => {
                        setFieldValue("OperationStage", newValue);
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID=${values.Milestone ? values.Milestone.RecordID : 0
                        }","Any":""}}`}
                    />

                    <Productautocomplete
                      name="Activities"
                      label="Activities"
                      variant="outlined"
                      id="Activities"
                      value={values.Activities}
                      onChange={(newValue) => {
                        setFieldValue("Activities", newValue);
                        console.log(newValue, "--newValue");
                        console.log(newValue.RecordID, "////");
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID=${values.OperationStage
                          ? values.OperationStage.RecordID
                          : 0
                        }","Any":""}}`}
                    />
                    {/* <Box>
                  <Field
                    //  size="small"
                    type="checkbox"
                    name="checkbox"
                    id="checkbox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    as={Checkbox}
                    label="Disable"
                  />

                  <FormLabel focused={false}>BackLog</FormLabel>
                </Box> */}
                  </React.Fragment>
                ) : (
                  false
                )}
                {!showImage ? (
                  <React.Fragment>
                    <Box
                      display="flex"
                      justifyContent="end"
                      padding={1}
                      gap={2}
                    >
                      {/* <FormControlLabel
                    control={
                      <Checkbox
                        type="checkbox"
                        name="checkbox"
                        id="checkbox"
                        as={Checkbox}
                        checked={values.checkbox}
                        onChange={handleChange}
                        onClick={() => handleApply(values)}
                        onBlur={handleBlur}
                        label="Backlog"
                      />
                    }
                    label="Backlog"
                  /> */}

                      {mode == "A" && (
                        <Checkbox
                          name="checkbox"
                          checked={values.checkbox}
                          onChange={(e) => {
                            handleChange(e); // this updates the form state
                            setTimeout(
                              () =>
                                handleApply({
                                  ...values,
                                  checkbox: e.target.checked,
                                }),
                              0
                            );
                          }}
                        />
                      )}

                      {mode == "A" && (
                        <Button
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={sprintPPgetloading}
                          onClick={() => handleApply(values)}
                        >
                          Apply
                        </Button>
                      )}
                      <PDFDownloadLink
                        document={
                          <SprintPDF
                            key={rows}
                            data={rows}
                            // projectName={projectName}
                            // managerName={managerName}
                            filters={{
                              Code: values.code,
                              Description: values.name,
                              FromDate: values.fromdate,
                              ToDate: values.todate,
                              Milestone: values.Milestone?.Name || "",
                              Stages: values.OperationStage?.Name || "",
                              Activities: values.Activities?.Name || "",
                              Imageurl: baseurl1,
                              HeaderImg: HeaderImg,
                              FooterImg: FooterImg,
                            }}
                          />
                        }
                        fileName={"Sprint.pdf"}
                        style={{ color: "#d32f2f", cursor: "pointer" }}
                      >
                        {({ loading }) =>
                          loading ? (
                            <PictureAsPdfIcon
                              sx={{ fontSize: 24, opacity: 0.5 }}
                            />
                          ) : (
                            <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                          )
                        }
                      </PDFDownloadLink>
                      <FaFileExcel
                        size={20}
                        color="#1D6F42"
                        style={{ cursor: "pointer", }}
                        onClick={() =>
                          sprintExcel(
                            rows,
                            {
                              Code: values.code,
                              Description: values.name,
                              FromDate: values.fromdate,
                              ToDate: values.todate,
                              Milestone: values.Milestone?.Name || "",
                              Stages: values.OperationStage?.Name || "",
                              Activities: values.Activities?.Name || "",
                            }
                            // { month: values.month, year: values.year },
                            // empData
                          )
                        }
                      />

                    </Box>
                  </React.Fragment>
                ) : (
                  false
                )}
              </Box>

              {!getLoading && !showImage ? (
                <Box m="5px">
                  <Box
                    m="5px 0 0 0"
                    height={dataGridHeight}
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={rows}
                      columns={Sprintcolumns}
                      loading={sprintPPgetloading}
                      rowModesModel={rowModesModel}
                      getRowId={(row) => row.RecordID}
                      editMode="cell"
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                      disableRowSelectionOnClick
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      experimentalFeatures={{ newEditingApi: true }}
                      onRowModesModelChange={handleRowModesModelChange}
                      processRowUpdate={processRowUpdate}
                      // onProcessRowUpdateError={handleProcessRowUpdateError}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      components={{
                        Toolbar: Custombar,
                      }}
                      componentsProps={{
                        toolbar: { setRows, setRowModesModel },
                      }}
                      // onPageSizeChange={(newPageSize) =>
                      //   setPageSize(newPageSize)
                      // }
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                    />
                  </Box>
                </Box>
              ) : (
                false
              )}

              <Box display="flex" justifyContent="end" padding={1} gap="20px">
                {/* {mode === "E" ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <FileUploadIconButton onFileSelect={fileUpload} />
                  </Box>
                ) : null} */}
                {/* {mode === "IM" ? (
                  <Button variant="contained" color="info" onClick={() => setShowImage(prev => !prev)}> {showImage ? 'Show Detail' : 'Hide Detail'}</Button>
                ) : null}
                {mode === "IM" ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <FileUploadIconButton onFileSelect={(file) =>
                      fileUpload(
                        file,
                        EMPID,
                        "upload"
                      )
                    } />
                  </Box>
                ) : null} */}
                {mode == "IM" && (
                  <>
                    <TextField
                      name="purpose"
                      type="text"
                      id="purpose"
                      label="Purpose"
                      variant="standard"
                      focused
                      value={values.purpose}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.purpose && !!errors.purpose}
                      helperText={touched.purpose && errors.purpose}
                      sx={{ gridColumn: "span 2", height: "20px", marginBottom: "5px" }}
                      InputLabelProps={{ shrink: true }}
                    />

                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton
                        onFileSelect={(file) => {
                          fileUpload(file, EMPID, "upload", "", values.purpose);
                          setFieldValue("purpose", "");
                        }}
                      />
                    </Box>
                  </>
                )}
                {/* {YearFlag == "true" ? ( */}
                {/* <LoadingButton
                     color="secondary"
                     variant="contained"
                     onClick={() => {
                       handleSaveButtonClick(values);
                   }}
                   >
                     Save
                   </LoadingButton> */}
                {/* ) : ( */}

                {mode == "A" && (
                  <Button
                    disabled={mode == "IM"}
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                      handleSaveButtonClick(values);
                    }}
                  //disabled={true}
                  >
                    Save
                  </Button>
                )}
                {/* )} */}
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          )}
        </Formik>
        <FileListPopup
          open={open}
          onClose={() => setOpen(false)}
          appId={recID}
          empId={EMPID}
        />
      </Paper>
      {mode === "IM" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Purpose</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                fileUpload(
                                  file.filename,
                                  EMPID,
                                  "delete",
                                  file.id,
                                  file.purpose
                                )
                              }
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default EditSprint;

//Row save--------------------------------------------------------------------------------------------------------------

// import {
//   TextField,
//   Box,
//   Checkbox,
//   FormLabel,
//   useTheme,
//   Typography,
//   Button,
//   IconButton,
//   Tooltip,
//   Breadcrumbs,
//   LinearProgress,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   FormControlLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Chip,
// } from "@mui/material";
// import dayjs from "dayjs";
// import {
//   dataGridHeaderFooterHeight,
//   dataGridHeight,
//   dataGridRowHeight,
//   formGap,
// } from "../../../ui-components/global/utils";
// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
// import LaunchIcon from "@mui/icons-material/Launch";

// import axios from "axios";
// import store from "../../..";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
// import ResetTvIcon from "@mui/icons-material/ResetTv";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-hot-toast";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import FileListPopup from "../../../ui-components/FIleViewDialog";
// import FileUploadIconButton from "../../../ui-components/FileUploadButton";
// import { attachmentPost } from "../../../store/reducers/LoginReducer";
// import GradingIcon from "@mui/icons-material/Grading";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import {
//   postData,
//   sprintGetData,
//   sprintprojectplanGetData,
//   SprintOccupancy,
// } from "../../../store/reducers/Formapireducer";
// import React, { useState, useEffect, useRef } from "react";
// import { LoadingButton } from "@mui/lab";
// import Swal from "sweetalert2";
// import { useProSidebar } from "react-pro-sidebar";
// import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import { tokens } from "../../../Theme";
// import {
//   DataGrid,
//   GridToolbarContainer,
//   GridActionsCellItem,
//   GridRowModes,
// } from "@mui/x-data-grid";
// import SaveIcon from "@mui/icons-material/Save";
// import CancelIcon from "@mui/icons-material/Cancel";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import {
//   Productautocomplete,
//   SprintEmpAutocomplete,
// } from "../../../ui-components/global/Autocomplete";
// import { Formik, Field } from "formik";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import { Mode } from "@mui/icons-material";
// import TimeSheetPDF from "../../reports/TimeSheetPdf";
// import SprintPDF from "../../reports/Sprintpdf";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import ErrorMsgData from "../../Security/validationMsg.json";
// import * as Yup from "yup";
// import { getConfig } from "../../../config";
// import sprintExcel from "../../reports/sprintExcel";
// import { FaFileExcel } from "react-icons/fa";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import CloseIcon from "@mui/icons-material/Close";
// import BusinessIcon from "@mui/icons-material/Business";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // ─── Occupied Hours Popup ───────────────────────────────────────────────────
// function OccupiedHrsPopup({
//   open,
//   onClose,
//   employeeName,
//   employeeRole,
//   fromDate,
//   toDate,
//   occupiedData,
// }) {
//   const grandTotal = occupiedData?.grandTotal || "0h";
//   const projects = occupiedData?.projects || [];

//   function formatDateToDDMMYYYY(dateStr) {
//     if (!dateStr) return "";
//     const [year, month, day] = dateStr.split("-");
//     if (!year || !month || !day) return "";
//     return `${day}-${month}-${year}`;
//   }

//   const statusColor = (status) => {
//     if (status === "In progress")
//       return { color: "#2e7d32", background: "#e8f5e9", border: "1px solid #a5d6a7" };
//     if (status === "Pending")
//       return { color: "#e65100", background: "#fff3e0", border: "1px solid #ffcc80" };
//     if (status === "Completed")
//       return { color: "#1565c0", background: "#e3f2fd", border: "1px solid #90caf9" };
//     return { color: "#555", background: "#f5f5f5", border: "1px solid #ddd" };
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           background: "linear-gradient(135deg, #4db6ac, #26a69a)",
//           px: 3,
//           py: 2,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//         }}
//       >
//         <Box display="flex" alignItems="center" gap={1}>
//           <AccessTimeIcon sx={{ color: "#fff" }} />
//           <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
//             Occupied hours — {employeeName}
//           </Typography>
//         </Box>
//       </Box>

//       <DialogContent sx={{ p: 0, background: "#f7fafa" }}>
//         {/* Employee info bar */}
//         <Box
//           sx={{
//             background: "#e0f2f1",
//             px: 3,
//             py: 1.5,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Box display="flex" alignItems="center" gap={1}>
//             <PersonOutlineIcon sx={{ color: "#26a69a" }} />
//             <Typography fontWeight={700} color="#26a69a">
//               {employeeName}
//             </Typography>
//             <Typography color="text.secondary" fontSize={13}>
//               {employeeRole}
//             </Typography>
//           </Box>
//           <Chip
//             label={`${grandTotal} occupied in range`}
//             size="small"
//             sx={{ background: "#b2dfdb", color: "#00695c", fontWeight: 600, fontSize: 12 }}
//           />
//         </Box>

//         {/* Date range */}
//         {fromDate && toDate && (
//           <Box
//             sx={{
//               background: "#fffde7",
//               px: 3,
//               py: 1,
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               borderBottom: "1px solid #f0f0f0",
//             }}
//           >
//             <CalendarTodayIcon sx={{ fontSize: 16, color: "#f9a825" }} />
//             <Typography fontSize={13} color="text.secondary">
//               Showing tasks between{" "}
//               <strong>{formatDateToDDMMYYYY(fromDate)}</strong> and{" "}
//               <strong>{formatDateToDDMMYYYY(toDate)}</strong>
//             </Typography>
//           </Box>
//         )}

//         {/* Projects */}
//         <Box sx={{ px: 2, py: 1.5 }}>
//           {projects.length === 0 ? (
//             <Typography color="text.secondary" textAlign="center" py={3}>
//               No tasks in this range.
//             </Typography>
//           ) : (
//             projects.map((proj, pi) => (
//               <Box
//                 key={pi}
//                 sx={{
//                   mb: 2,
//                   border: "1px solid #e0e0e0",
//                   borderRadius: "10px",
//                   overflow: "hidden",
//                 }}
//               >
//                 {/* Project header */}
//                 <Box
//                   sx={{
//                     background: "#fff",
//                     px: 2,
//                     py: 1,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     borderBottom: "1px solid #e0e0e0",
//                   }}
//                 >
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <BusinessIcon sx={{ fontSize: 18, color: "#26a69a" }} />
//                     <Typography fontWeight={700} fontSize={14}>
//                       {proj.projectName}
//                     </Typography>
//                   </Box>
//                   <Box display="flex" alignItems="center" gap={0.5}>
//                     <PersonOutlineIcon sx={{ fontSize: 15, color: "#aaa" }} />
//                     <Typography fontSize={12} color="text.secondary">
//                       {proj.pm}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Task table */}
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow sx={{ background: "#fafafa" }}>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888", width: 30 }}>
//                         #
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888" }}>
//                         Task name
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888", width: 100 }}>
//                         Date
//                       </TableCell>
//                       <TableCell
//                         sx={{ fontSize: 12, fontWeight: 600, color: "#26a69a", textAlign: "center" }}
//                       >
//                         Hrs
//                       </TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888" }}>
//                         Status
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {proj.tasks.map((task, ti) => (
//                       <TableRow
//                         key={ti}
//                         sx={{ "&:nth-of-type(even)": { background: "#f9f9f9" } }}
//                       >
//                         <TableCell sx={{ fontSize: 12, color: "#aaa" }}>{ti + 1}</TableCell>
//                         <TableCell sx={{ fontSize: 13 }}>{task.name}</TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "#555", width: 100 }}>
//                           {task.from}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             fontSize: 13,
//                             color: "#26a69a",
//                             fontWeight: 700,
//                             textAlign: "center",
//                           }}
//                         >
//                           {task.hrs}
//                         </TableCell>
//                         <TableCell>
//                           <Box
//                             sx={{
//                               display: "inline-block",
//                               px: 1,
//                               py: 0.3,
//                               borderRadius: "12px",
//                               fontSize: 11,
//                               fontWeight: 600,
//                               ...statusColor(task.status),
//                             }}
//                           >
//                             {task.status}
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                     <TableRow>
//                       <TableCell
//                         colSpan={4}
//                         align="right"
//                         sx={{ fontSize: 12, color: "#888", fontStyle: "italic" }}
//                       >
//                         Project total in range
//                       </TableCell>
//                       <TableCell
//                         sx={{ fontSize: 14, color: "#26a69a", fontWeight: 700, textAlign: "center" }}
//                       >
//                         {proj.projectTotal}
//                       </TableCell>
//                       <TableCell />
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </Box>
//             ))
//           )}
//         </Box>

//         {/* Grand total */}
//         <Box
//           sx={{
//             px: 3,
//             py: 1.5,
//             display: "flex",
//             justifyContent: "flex-end",
//             borderTop: "1px solid #e0e0e0",
//             background: "#fff",
//           }}
//         >
//           <Typography fontWeight={700} fontSize={14}>
//             Grand total:{" "}
//             <span style={{ color: "#26a69a", fontSize: 16 }}>{grandTotal}</span>
//           </Typography>
//         </Box>
//       </DialogContent>

//       <DialogActions
//         sx={{ background: "#fff", justifyContent: "flex-end", px: 3, py: 1.5 }}
//       >
//         <Button
//           variant="outlined"
//           onClick={onClose}
//           sx={{ borderRadius: "8px", textTransform: "none", minWidth: 80 }}
//         >
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// // ─── Main Component ──────────────────────────────────────────────────────────
// const EditSprint = (empId, appId) => {
//   const isNonMobile = useMediaQuery("(min-width:600px)");
//   const navigate = useNavigate();
//   let params = useParams();

//   const dispatch = useDispatch();
//   var recID = params.id;
//   var mode = params.Mode;
//   const getLoading = useSelector((state) => state.formApi.sprintloading);
//   const SprintGEtdata = useSelector((state) => state.formApi.sprintget) || {};
//   const listViewurl = useSelector((state) => state.globalurl.listViewurl);

//   const sprintPPgetloading = useSelector((state) => state.formApi.sprintloading);
//   const YearFlag = sessionStorage.getItem("YearFlag");
//   const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
//   console.log(CompanyAutoCode, "CompanyAutoCode");

//   const { toggleSidebar, broken, rtl } = useProSidebar();
//   const CompanyID = sessionStorage.getItem("companyId");
//   const [files, setFiles] = useState([]);
//   const [page, setPage] = React.useState(0);
//   const [pageSize, setPageSize] = useState(15);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
//   const EMPID = sessionStorage.getItem("EmpId");
//   const location = useLocation();
//   const state = location.state || {};
//   const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [errorMsgData, setErrorMsgData] = useState(null);
//   const [validationSchema, setValidationSchema] = useState(null);

//   const HeaderImg = sessionStorage.getItem("CompanyHeader");
//   const FooterImg = sessionStorage.getItem("CompanyFooter");
//   const config = getConfig();
//   const baseurl1 = config.UAAM_URL;

//   // ── Occupied Hrs popup state ──────────────────────────────────────────────
//   const [occupiedPopup, setOccupiedPopup] = useState({
//     open: false,
//     employeeName: "",
//     employeeRole: "",
//     fromDate: "",
//     toDate: "",
//     occupiedData: null,
//   });
//   const [occupiedLoading, setOccupiedLoading] = useState(false);

//   // ── Ref to keep latest Formik header values accessible inside grid callbacks ──
//   const formikValuesRef = useRef({});
//   const dateRangeRef = useRef({
//     fromdate: SprintGEtdata.FromDate || "",
//     todate: SprintGEtdata.ToDate || "",
//   });

//   useEffect(() => {
//     fetch(process.env.PUBLIC_URL + "/validationcms.json")
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch validationcms.json");
//         return res.json();
//       })
//       .then((data) => {
//         setErrorMsgData(data);
//         let schemaFields = {};
//         if (CompanyAutoCode === "N") {
//           schemaFields.code = Yup.string().required(data.Routinetask.code);
//         }
//         const schema = Yup.object().shape(schemaFields);
//         setValidationSchema(schema);
//       })
//       .catch((err) => console.error("Error loading validationcms.json:", err));
//   }, [CompanyAutoCode]);

//   useEffect(() => {
//     GetSprintData();
//     var url = store.getState().globalurl.empGetAttachmentUrl;
//     axios
//       .get(url, { params: { empId: EMPID, appId: recID } })
//       .then((response) => setFiles(response.data))
//       .catch((err) => {
//         setError("Failed to fetch attachments.");
//         console.error(err);
//       })
//       .finally(() => setLoading(false));
//   }, [location.key]);

//   async function GetSprintData() {
//     dispatch(sprintGetData({ SprintHeaderID: recID })).then((res) => {
//       if (res.payload.Status == "Y") {
//         const resData = res.payload.Data.detailData.map((value) => ({
//           ...value,
//           ScheduledTo: {
//             RecordID: value.ScheduledTo,
//             Name: value.EmployeeName,
//           },
//         }));
//         setRows(resData);
//       } else {
//         setRows([]);
//       }
//     });
//   }

//   // ── State ─────────────────────────────────────────────────────────────────
//   const [rowModesModel, setRowModesModel] = useState({});
//   const [funMode, setFunMode] = useState(mode);
//   const [open, setOpen] = useState(false);
//   const [selectedRoleOptions, setSelectedRoleOptions] = useState(null);
//   const [selectedScheduledToOptions, setSelectedScheduledToOptions] = useState(null);
//   const [rows, setRows] = useState([]);

//   const InitialValue = {
//     code: SprintGEtdata.Code,
//     name: SprintGEtdata.Name,
//     Milestone: SprintGEtdata.MilestoneID
//       ? { RecordID: SprintGEtdata.MilestoneID, Name: SprintGEtdata.MilestoneName }
//       : "",
//     OperationStage: SprintGEtdata.OperationStageID
//       ? { RecordID: SprintGEtdata.OperationStageID, Name: SprintGEtdata.OperationName }
//       : null,
//     Activities: SprintGEtdata.ActivitiesID
//       ? { RecordID: SprintGEtdata.ActivitiesID, Name: SprintGEtdata.ActivitiesName }
//       : null,
//     fromdate: SprintGEtdata.FromDate,
//     todate: SprintGEtdata.ToDate,
//     checkbox: SprintGEtdata.BackLog === "Y" ? true : false,
//   };

//   const handleApply = async (values) => {
//     const data = await dispatch(
//       sprintprojectplanGetData({
//         ActivitiesID: values.Activities ? values.Activities.RecordID : 0,
//         FromDate: values.fromdate,
//         ToDate: values.todate,
//         BackLog: values.checkbox === true ? "Y" : "N",
//       })
//     );
//     if (data.payload.Status === "Y") {
//       const resData = data.payload.Data.map((row) => ({
//         ...row,
//         ScheduledTo: row.ScheduledTo
//           ? { EmployeeID: row.ScheduledTo, Name: row.EmployeeName }
//           : null,
//       }));
//       setRows(resData);
//     } else {
//       setRows([]);
//     }
//   };

//   // ── Row-level API save ────────────────────────────────────────────────────
//   /**
//    * Saves a single edited row by building the full payload from header values
//    * (via formikValuesRef) and submitting only that one row in Details[].
//    * Returns the updated row on success, throws on failure (keeps edit mode).
//    */
//   const saveRowToApi = async (newRow) => {
//     const values = formikValuesRef.current;

//     // Basic validation: ScheduledTo is required
//     if (!newRow.ScheduledTo || !newRow.ScheduledTo.EmployeeID) {
//       throw new Error("Scheduled To is required.");
//     }

//     const idata = {
//       RecordID: recID,
//       Code: values.code || "",
//       Name: values.name || "",
//       MilestoneID: values.Milestone ? values.Milestone.RecordID : 0,
//       MilestoneName: values.Milestone ? values.Milestone.Name : "",
//       OperationStageID: values.OperationStage ? values.OperationStage.RecordID : 0,
//       OperationStageName: values.OperationStage ? values.OperationStage.Name : "",
//       ActivitiesID: values.Activities ? values.Activities.RecordID : 0,
//       ActivitiesName: values.Activities ? values.Activities.Name : "",
//       FromDate: values.fromdate || "",
//       ToDate: values.todate || "",
//       ProjectID: params.filtertype,
//       LoginUser: EMPID,
//       BackLog: values.checkbox === true ? "Y" : "N",
//       Details: [
//         {
//           Task: newRow.Task || "",
//           RoleID: newRow.RoleID || "",
//           Effort: newRow.Effort || "",
//           ProjectPlanDate: newRow.ProjectPlanDate || "",
//           ScheduledDate: newRow.ScheduledDate || "",
//           CompletedDate: newRow.CompletedDate || "",
//           ScheduledTo: newRow.ScheduledTo?.EmployeeID || "0",
//           TaskDetailID: newRow.RecordID || "",
//           Status: newRow.Status || "SH",
//           Comments: newRow.Comments || "",
//         },
//       ],
//     };

//     const response = await dispatch(
//       postData({
//         accessID: "TR262",
//         action: mode === "A" ? "insert" : "update",
//         idata,
//       })
//     );

//     if (response.payload.Status === "Y") {
//       toast.success(response.payload.Msg);
//       return { ...newRow, isNew: false, isUpdated: false };
//     } else {
//       throw new Error(response.payload.Msg || response.payload.Data || "Save failed.");
//     }
//   };

//   // ── processRowUpdate — called by DataGrid when a row exits edit mode ──────
//   const processRowUpdate = async (newRow, oldRow) => {
//     console.log(" processRowUpdate:", newRow);

//     try {
//       const updatedRow = await saveRowToApi(newRow);

//       // Reflect saved row in local state
//       setRows((prev) =>
//         prev.map((row) => (row.RecordID === updatedRow.RecordID ? updatedRow : row))
//       );

//       return updatedRow; // DataGrid uses this as the committed row value
//     } catch (err) {
//       console.error(" Row save failed:", err);
//       toast.error(err.message || "Error occurred during save.");
//       throw err; // Keeps the row in edit mode so the user can fix and retry
//     }
//   };

//   const handleProcessRowUpdateError = (err) => {
//     // Errors already toasted in processRowUpdate; this silences the DataGrid
//     // default error boundary while still logging for debugging.
//     console.error("processRowUpdateError:", err);
//   };

//   // ── Grid action handlers ──────────────────────────────────────────────────
//   const handleEditClick = (id) => () => {
//     setFunMode("E");
//     setRowModesModel((prev) => ({ ...prev, [id]: { mode: GridRowModes.Edit } }));
//   };

//   const handleSave = (id) => () => {
//     setRowModesModel((prev) => ({ ...prev, [id]: { mode: GridRowModes.View } }));
//   };

//   const handleCancelClick = (id) => () => {
//     setRowModesModel((prev) => ({
//       ...prev,
//       [id]: { mode: GridRowModes.View, ignoreModifications: true },
//     }));
//     setSelectedRoleOptions(null);
//   };

//   const handleDeleteClick = (id) => async () => {
//     console.log(" ~ handleDeleteClick ~ id:", id);
//     try {
//       setRows((prev) => prev.filter((row) => row.RecordID !== id));
//     } catch (error) {
//       console.error("Error deleting row:", error);
//       toast.error("Error occurred during delete.");
//     }
//   };

//   const handleRowModesModelChange = (newRowModesModel) => {
//     setRowModesModel(newRowModesModel);
//     setSelectedRoleOptions(null);
//     setSelectedScheduledToOptions(null);
//   };

//   // ── Logout / Close ────────────────────────────────────────────────────────
//   const fnLogOut = (props) => {
//     Swal.fire({
//       title: errorMsgData?.Warningmsg?.[props] || `Are you sure you want to ${props}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: props,
//     }).then((result) => {
//       if (result.isConfirmed) {
//         if (props === "Logout") navigate("/");
//         if (props === "Close") navigate(-1);
//       }
//     });
//   };

//   // ── Toolbar ───────────────────────────────────────────────────────────────
//   const [rowCount, setRowCount] = useState(0);

//   function Custombar() {
//     return (
//       <GridToolbarContainer
//         sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
//       >
//         <Box sx={{ display: "flex", flexDirection: "row" }}>
//           <Typography>List of Sprint Task</Typography>
//           <Typography variant="h5">{`(${rowCount})`}</Typography>
//         </Box>
//       </GridToolbarContainer>
//     );
//   }

//   // ── Edit cell renderers ───────────────────────────────────────────────────
//   function EditAutocompleteCell(props) {
//     const { id, value, field, api, row } = props;
//     const [Employee, setEmployee] = useState(row.ScheduledTo ? row.ScheduledTo : null);

//     const handleChange = async (newValue) => {
//       if (!newValue) return;
//       setEmployee(newValue);
//       await api.setEditCellValue({ id, field: "ScheduledTo", value: newValue });

//       setRows((prev) =>
//         prev.map((r) =>
//           r.RecordID === row.RecordID
//             ? {
//               ...r,
//               ScheduledTo: newValue,
//               OccupiedHrs:
//                 newValue.OccupiedHrs !== undefined ? newValue.OccupiedHrs : r.OccupiedHrs,
//             }
//             : r
//         )
//       );

//       api.stopCellEditMode({ id, field });
//     };

//     return (
//       <SprintEmpAutocomplete
//         name="ScheduledTo"
//         label="ScheduledTo"
//         id="ScheduledTo"
//         value={Employee}
//         onChange={handleChange}
//         url={`${listViewurl}?data={"Query":{"AccessID":"2109","ScreenName":"Scheduled To","Filter":"DesignationID='${row.DesignationsID
//           }' AND ProjectID='${state.projectID || params.filtertype}'","Any":""}}`}
//       />
//     );
//   }

//   function EditDateCell(props) {
//     const { id, field, value, api } = props;

//     const formatToInputDate = (val) => {
//       if (!val) return "";
//       const date = new Date(val);
//       if (isNaN(date.getTime())) return "";
//       return date.toISOString().split("T")[0];
//     };

//     const handleChange = (event) => {
//       api.setEditCellValue({ id, field, value: event.target.value });
//     };

//     return (
//       <TextField
//         type="date"
//         fullWidth
//         size="small"
//         value={formatToInputDate(value)}
//         onChange={handleChange}
//         InputLabelProps={{ shrink: true }}
//       />
//     );
//   }

//   function formatDateToDDMMYYYY(dateStr) {
//     if (!dateStr) return "";
//     const [year, month, day] = dateStr.split("-");
//     if (!year || !month || !day) return "";
//     return `${day}-${month}-${year}`;
//   }

//   // ── Occupied hours popup ──────────────────────────────────────────────────
//   const handleOpenOccupied = async (row, fromDate, toDate) => {
//     const empName = row.ScheduledTo?.Name || row.EmployeeName || "";
//     const empRole = row.DesignationsName || "";
//     const employeeID = row.ScheduledTo?.EmployeeID || row.EmployeeID || 0;

//     setOccupiedLoading(true);
//     setOccupiedPopup({
//       open: true,
//       employeeName: empName,
//       employeeRole: empRole,
//       fromDate: fromDate || "",
//       toDate: toDate || "",
//       occupiedData: null,
//     });

//     try {
//       const res = await dispatch(
//         SprintOccupancy({ EmployeeID: employeeID, FromDate: fromDate || "", ToDate: toDate || "" })
//       );
//       const payload = res?.payload;

//       if (payload?.Status === "Y") {
//         const emp = payload.Employee || {};
//         const grandTotal = `${payload.RangeTotalHours ?? emp.OverallOccupied ?? 0}h`;

//         const projects = (payload.Projects || []).map((proj) => ({
//           projectName: proj.ProjectName,
//           stage: "",
//           pm: proj.InchargeName || "",
//           projectTotal: `${proj.SubtotalHours ?? 0}h`,
//           tasks: proj.Tasks?.map((t) => ({
//             name: t.TaskName,
//             from: t.TaskDate,
//             to: t.TaskDate,
//             hrs: `${t.EstHours}h`,
//             status: t.Status || "—",
//           })),
//         }));

//         setOccupiedPopup((prev) => ({
//           ...prev,
//           employeeRole: emp.Designation || empRole,
//           occupiedData: { grandTotal, projects },
//         }));
//       } else {
//         setOccupiedPopup((prev) => ({
//           ...prev,
//           occupiedData: { grandTotal: "0h", projects: [] },
//         }));
//       }
//     } catch (err) {
//       console.error("SprintOccupancy error:", err);
//       setOccupiedPopup((prev) => ({
//         ...prev,
//         occupiedData: { grandTotal: "0h", projects: [] },
//       }));
//     } finally {
//       setOccupiedLoading(false);
//     }
//   };

//   const getOccupiedLabel = (row) => {
//     const empName = row.ScheduledTo?.Name || row.EmployeeName || "";
//     if (!empName) return null;
//     const rawHrs = parseFloat(row.OccupiedHrs);
//     if (isNaN(rawHrs)) return null;
//     const isOverloaded = rawHrs > 40;
//     return { label: `${rawHrs}h`, isOverloaded };
//   };

//   // ── Grid columns ──────────────────────────────────────────────────────────
//   const Sprintcolumns = [
//     {
//       field: "slno",
//       headerName: "SL#",
//       width: 60,
//       sortable: false,
//       filterable: false,
//       disableColumnMenu: true,
//       valueGetter: (params) => {
//         const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
//         const totalVisibleRows = params.api.getAllRowIds().length;
//         const totalAllRows = params.api.getRowsCount();
//         if (totalVisibleRows < totalAllRows) return index + 1;
//         return page * pageSize + index + 1;
//       },
//     },
//     {
//       headerName: "Task",
//       field: "Task",
//       width: 250,
//       align: "left",
//       headerAlign: "center",
//       editable: false,
//     },
//     {
//       headerName: "Role",
//       field: "DesignationsName",
//       width: 200,
//       align: "left",
//       headerAlign: "center",
//       editable: false,
//     },
//     {
//       headerName: "Effort",
//       field: "Effort",
//       width: 100,
//       align: "right",
//       headerAlign: "center",
//       editable: false,
//     },
//     {
//       headerName: "Project Plan Date",
//       field: "ProjectPlanDate",
//       type: "date",
//       width: 150,
//       align: "left",
//       headerAlign: "center",
//       editable: false,
//     },
//     {
//       headerName: "Scheduled Date",
//       field: "ScheduledDate",
//       width: 100,
//       editable: true,
//       renderEditCell: (params) => <EditDateCell {...params} />,
//     },
//     {
//       field: "ScheduledTo",
//       headerName: (
//         <span>
//           Scheduled To <span style={{ color: "red" }}>*</span>
//         </span>
//       ),
//       width: 150,
//       align: "left",
//       headerAlign: "center",
//       editable: true,
//       sortable: false,
//       renderCell: (params) => params.value?.Name || "",
//       renderEditCell: (params) => <EditAutocompleteCell {...params} />,
//     },
//     {
//       field: "OccupiedHours",
//       headerName: "Occupied Hrs",
//       width: 160,
//       align: "left",
//       headerAlign: "center",
//       editable: false,
//       sortable: false,
//       renderCell: (params) => {
//         const info = getOccupiedLabel(params.row);
//         if (!info || info.occupiedHrs <= 0) return null;
//         return (
//           <Box
//             onClick={() =>
//               handleOpenOccupied(
//                 params.row,
//                 dateRangeRef.current.fromdate,
//                 dateRangeRef.current.todate
//               )
//             }
//             sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}
//           >
//             <Typography sx={{ fontSize: 13 }}>{info.label} occupied</Typography>
//             <LaunchIcon sx={{ fontSize: 15 }} />
//           </Box>
//         );
//       },
//     },
//     ...(mode === "E"
//       ? [
//         {
//           headerName: "Completed Date",
//           field: "CompletedDate",
//           type: "date",
//           width: 150,
//           editable: false,
//         },
//       ]
//       : []),
//     {
//       headerName: "Comments",
//       field: "Comments",
//       width: 220,
//       editable: true,
//     },
//     {
//       headerName: "Status",
//       field: "Status",
//       width: 100,
//       align: "left",
//       headerAlign: "center",
//       editable: false,
//     },
//     {
//       field: "actions",
//       type: "actions",
//       headerName: "Actions",
//       width: 150,
//       cellClassName: "actions",
//       getActions: (params) => {
//         const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

//         if (isInEditMode) {
//           return [
//             <GridActionsCellItem
//               icon={<SaveIcon />}
//               label="Save"
//               sx={{ color: "#009688" }}
//               onClick={handleSave(params.id)}
//             />,
//             <GridActionsCellItem
//               icon={<CancelIcon />}
//               label="Cancel"
//               onClick={handleCancelClick(params.id)}
//               color="inherit"
//             />,
//           ];
//         }

//         return [
//           <GridActionsCellItem
//             icon={<EditIcon style={{ color: "#3498db" }} />}
//             label="Edit"
//             onClick={handleEditClick(params.id)}
//             color="inherit"
//           />,
//           <GridActionsCellItem
//             icon={<DeleteIcon style={{ color: "#e74c3c" }} />}
//             label="Delete"
//             onClick={handleDeleteClick(params.id)}
//             color="inherit"
//           />,
//         ];
//       },
//     },
//   ];

//   // ── File upload ───────────────────────────────────────────────────────────
//   async function fileUpload(file, EMPID, action, id, purpose) {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("empId", EMPID);
//     formData.append("appId", recID);
//     formData.append("type", "SP");
//     formData.append("source", "Sprint");
//     formData.append("action", action);
//     formData.append("id", id);
//     formData.append("purpose", purpose ? purpose : "");

//     const respose = await dispatch(attachmentPost({ data: formData }));

//     if (respose.payload.success) {
//       toast.success(respose.payload.message);
//       var url = store.getState().globalurl.empGetAttachmentUrl;
//       axios
//         .get(url, { params: { empId: EMPID, appId: recID } })
//         .then((response) => setFiles(response.data))
//         .catch((err) => {
//           setError("Failed to fetch attachments.");
//           console.error(err);
//         })
//         .finally(() => setLoading(false));
//     } else {
//       toast.success(respose.payload.message);
//     }
//   }

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <React.Fragment>
//       {getLoading ? <LinearProgress /> : false}

//       {/* ── Header bar ── */}
//       <Paper
//         elevation={3}
//         sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
//       >
//         <Box display="flex" justifyContent="space-between">
//           <Box display="flex" borderRadius="3px" alignItems="center">
//             {broken && !rtl && (
//               <IconButton onClick={() => toggleSidebar()}>
//                 <MenuOutlinedIcon />
//               </IconButton>
//             )}
//             <Breadcrumbs
//               maxItems={1}
//               aria-label="breadcrumb"
//               separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
//             >
//               <Typography
//                 variant="h5"
//                 color="#0000D1"
//                 sx={{ cursor: "default", marginLeft: "10px" }}
//                 onClick={() => navigate(-1)}
//               >
//                 Sprint
//               </Typography>
//             </Breadcrumbs>
//           </Box>

//           <Box display="flex">
//             <Tooltip title="Close">
//               <IconButton onClick={() => fnLogOut("Close")} color="error">
//                 <ResetTvIcon />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Logout">
//               <IconButton color="error" onClick={() => fnLogOut("Logout")}>
//                 <LogoutOutlinedIcon />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Box>
//       </Paper>

//       {/* ── Form ── */}
//       <Paper elevation={3} sx={{ margin: "10px" }}>
//         {mode === "IM" && (
//           <Box
//             display="flex"
//             padding={1}
//             justifyContent="flex-end"
//             mt="2px"
//             gridColumn="span 4"
//             gap={2}
//             marginBottom={-5}
//           >
//             <IconButton onClick={() => setShowImage((prev) => !prev)} sx={{ padding: "12px" }}>
//               <ArrowDownwardIcon sx={{ color: "blue", marginBottom: "8px" }} />
//             </IconButton>
//           </Box>
//         )}

//         <Formik
//           initialValues={InitialValue}
//           onSubmit={(values) => {
//             setTimeout(() => handleApply(values), 100);
//           }}
//           enableReinitialize={true}
//           validationSchema={validationSchema}
//         >
//           {({
//             errors,
//             touched,
//             handleBlur,
//             handleChange,
//             isSubmitting,
//             values,
//             handleSubmit,
//             setFieldValue,
//           }) => {
//             // Keep ref in sync so grid callbacks can read latest header values
//             formikValuesRef.current = values;
//             dateRangeRef.current = {
//               fromdate: values.fromdate || "",
//               todate: values.todate || "",
//             };

//             return (
//               <form onSubmit={handleSubmit}>
//                 <Box
//                   display="grid"
//                   gap={formGap}
//                   padding={1}
//                   gridTemplateColumns="repeat(2, minMax(0,1fr))"
//                   sx={{
//                     "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
//                   }}
//                 >
//                   {/* Code */}
//                   {CompanyAutoCode == "Y" ? (
//                     <TextField
//                       name="code"
//                       type="text"
//                       id="code"
//                       label="Code"
//                       variant="standard"
//                       placeholder="Auto"
//                       focused
//                       value={values.code}
//                       onBlur={handleBlur}
//                       onChange={handleChange}
//                       error={!!touched.code && !!errors.code}
//                       helperText={touched.code && errors.code}
//                       InputProps={{ readOnly: true }}
//                     />
//                   ) : (
//                     <TextField
//                       name="code"
//                       type="text"
//                       id="code"
//                       label={
//                         <>
//                           Code
//                           <span style={{ color: "red", fontSize: "20px" }}> * </span>
//                         </>
//                       }
//                       variant="standard"
//                       focused
//                       value={values.code}
//                       onBlur={handleBlur}
//                       onChange={handleChange}
//                       error={!!touched.code && !!errors.code}
//                       helperText={touched.code && errors.code}
//                       autoFocus
//                     />
//                   )}

//                   {/* Description */}
//                   <TextField
//                     name="name"
//                     type="text"
//                     id="name"
//                     label="Description"
//                     variant="standard"
//                     focused
//                     value={values.name}
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                     error={!!touched.name && !!errors.name}
//                     helperText={touched.name && errors.name}
//                     autoFocus={CompanyAutoCode == "Y"}
//                   />

//                   {!showImage && (
//                     <React.Fragment>
//                       {/* From Date */}
//                       <TextField
//                         name="fromdate"
//                         type="date"
//                         id="fromdate"
//                         label="From Date"
//                         variant="standard"
//                         focused
//                         value={values.fromdate}
//                         onBlur={handleBlur}
//                         onChange={handleChange}
//                         error={!!touched.fromdate && !!errors.fromdate}
//                         helperText={touched.fromdate && errors.fromdate}
//                         InputLabelProps={{ shrink: true }}
//                       />

//                       {/* To Date */}
//                       <TextField
//                         name="todate"
//                         type="date"
//                         id="todate"
//                         label="To Date"
//                         variant="standard"
//                         focused
//                         value={values.todate}
//                         onBlur={handleBlur}
//                         onChange={handleChange}
//                         error={!!touched.todate && !!errors.todate}
//                         helperText={touched.todate && errors.todate}
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           inputProps: {
//                             min: values.fromdate || undefined,
//                             max: values.fromdate
//                               ? dayjs(values.fromdate).add(6, "day").format("YYYY-MM-DD")
//                               : undefined,
//                           },
//                         }}
//                       />

//                       {/* Milestone */}
//                       <Productautocomplete
//                         sx={{ marginTop: "7px" }}
//                         name="Milestone"
//                         label="Milestone"
//                         variant="outlined"
//                         id="Milestone"
//                         value={values.Milestone}
//                         getOptionLabel={(option) => option?.Name || ""}
//                         onChange={(newValue) => setFieldValue("Milestone", newValue)}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"ParentID=${params.filtertype} AND CompanyID=${CompanyID}","Any":""}}`}
//                       />

//                       {/* Operation Stage */}
//                       <Productautocomplete
//                         sx={{ marginTop: "7px" }}
//                         name="OperationStage"
//                         label="Operation Stage"
//                         variant="outlined"
//                         id="OperationStage"
//                         value={values.OperationStage}
//                         onChange={(newValue) => setFieldValue("OperationStage", newValue)}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID=${values.Milestone ? values.Milestone.RecordID : 0
//                           }","Any":""}}`}
//                       />

//                       {/* Activities */}
//                       <Productautocomplete
//                         name="Activities"
//                         label="Activities"
//                         variant="outlined"
//                         id="Activities"
//                         value={values.Activities}
//                         onChange={(newValue) => {
//                           setFieldValue("Activities", newValue);
//                         }}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID=${values.OperationStage ? values.OperationStage.RecordID : 0
//                           }","Any":""}}`}
//                       />
//                     </React.Fragment>
//                   )}

//                   {!showImage && (
//                     <React.Fragment>
//                       <Box display="flex" justifyContent="end" padding={1} gap={2}>
//                         {mode == "A" && (
//                           <Checkbox
//                             name="checkbox"
//                             checked={values.checkbox}
//                             onChange={(e) => {
//                               handleChange(e);
//                               setTimeout(
//                                 () => handleApply({ ...values, checkbox: e.target.checked }),
//                                 0
//                               );
//                             }}
//                           />
//                         )}

//                         {mode == "A" && (
//                           <Button
//                             color="secondary"
//                             variant="contained"
//                             type="submit"
//                             loading={sprintPPgetloading}
//                             onClick={() => handleApply(values)}
//                           >
//                             Apply
//                           </Button>
//                         )}

//                         {/* PDF export */}
//                         <PDFDownloadLink
//                           document={
//                             <SprintPDF
//                               key={rows}
//                               data={rows}
//                               filters={{
//                                 Code: values.code,
//                                 Description: values.name,
//                                 FromDate: values.fromdate,
//                                 ToDate: values.todate,
//                                 Milestone: values.Milestone?.Name || "",
//                                 Stages: values.OperationStage?.Name || "",
//                                 Activities: values.Activities?.Name || "",
//                                 Imageurl: baseurl1,
//                                 HeaderImg: HeaderImg,
//                                 FooterImg: FooterImg,
//                               }}
//                             />
//                           }
//                           fileName={"Sprint.pdf"}
//                           style={{ color: "#d32f2f", cursor: "pointer" }}
//                         >
//                           {({ loading }) =>
//                             loading ? (
//                               <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
//                             ) : (
//                               <PictureAsPdfIcon sx={{ fontSize: 24 }} />
//                             )
//                           }
//                         </PDFDownloadLink>

//                         {/* Excel export */}
//                         <FaFileExcel
//                           size={20}
//                           color="#1D6F42"
//                           style={{ cursor: "pointer" }}
//                           onClick={() =>
//                             sprintExcel(rows, {
//                               Code: values.code,
//                               Description: values.name,
//                               FromDate: values.fromdate,
//                               ToDate: values.todate,
//                               Milestone: values.Milestone?.Name || "",
//                               Stages: values.OperationStage?.Name || "",
//                               Activities: values.Activities?.Name || "",
//                             })
//                           }
//                         />
//                       </Box>
//                     </React.Fragment>
//                   )}
//                 </Box>

//                 {/* ── DataGrid ── */}
//                 {!getLoading && !showImage && (
//                   <Box m="5px">
//                     <Box
//                       m="5px 0 0 0"
//                       height={dataGridHeight}
//                       sx={{
//                         "& .MuiDataGrid-root": { border: "none" },
//                         "& .MuiDataGrid-cell": { borderBottom: "none" },
//                         "& .name-column--cell": { color: colors.greenAccent[300] },
//                         "& .MuiDataGrid-columnHeaders": {
//                           backgroundColor: colors.blueAccent[800],
//                           borderBottom: "none",
//                         },
//                         "& .MuiDataGrid-virtualScroller": {
//                           backgroundColor: colors.primary[400],
//                         },
//                         "& .MuiDataGrid-footerContainer": {
//                           borderTop: "none",
//                           backgroundColor: colors.blueAccent[800],
//                         },
//                         "& .MuiCheckbox-root": {
//                           color: `${colors.greenAccent[200]} !important`,
//                         },
//                         "& .odd-row": { backgroundColor: "" },
//                         "& .even-row": { backgroundColor: "#D3D3D3" },
//                       }}
//                     >
//                       <DataGrid
//                         sx={{
//                           "& .MuiDataGrid-footerContainer": {
//                             height: dataGridHeaderFooterHeight,
//                             minHeight: dataGridHeaderFooterHeight,
//                           },
//                         }}
//                         rows={rows}
//                         columns={Sprintcolumns}
//                         loading={sprintPPgetloading}
//                         rowModesModel={rowModesModel}
//                         getRowId={(row) => row.RecordID}
//                         editMode="cell"
//                         pageSize={pageSize}
//                         page={page}
//                         onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//                         onPageChange={(newPage) => setPage(newPage)}
//                         disableRowSelectionOnClick
//                         rowHeight={dataGridRowHeight}
//                         headerHeight={dataGridHeaderFooterHeight}
//                         experimentalFeatures={{ newEditingApi: true }}
//                         onRowModesModelChange={handleRowModesModelChange}
//                         processRowUpdate={processRowUpdate}
//                         onProcessRowUpdateError={handleProcessRowUpdateError}
//                         onStateChange={(stateParams) =>
//                           setRowCount(stateParams.pagination.rowCount)
//                         }
//                         components={{ Toolbar: Custombar }}
//                         componentsProps={{ toolbar: { setRows, setRowModesModel } }}
//                         rowsPerPageOptions={[5, 10, 20]}
//                         getRowClassName={(params) =>
//                           params.indexRelativeToCurrentPage % 2 === 0 ? "odd-row" : "even-row"
//                         }
//                         pagination
//                       />
//                     </Box>
//                   </Box>
//                 )}

//                 {/* ── Bottom action bar ── */}
//                 <Box display="flex" justifyContent="end" padding={1} gap="20px">
//                   {mode == "IM" && (
//                     <>
//                       <TextField
//                         name="purpose"
//                         type="text"
//                         id="purpose"
//                         label="Purpose"
//                         variant="standard"
//                         focused
//                         value={values.purpose}
//                         onBlur={handleBlur}
//                         onChange={handleChange}
//                         error={!!touched.purpose && !!errors.purpose}
//                         helperText={touched.purpose && errors.purpose}
//                         sx={{
//                           gridColumn: "span 2",
//                           height: "20px",
//                           marginBottom: "5px",
//                         }}
//                         InputLabelProps={{ shrink: true }}
//                       />
//                       <Box display="flex" alignItems="center" gap={1}>
//                         <FileUploadIconButton
//                           onFileSelect={(file) => {
//                             fileUpload(file, EMPID, "upload", "", values.purpose);
//                             setFieldValue("purpose", "");
//                           }}
//                         />
//                       </Box>
//                     </>
//                   )}

//                   {/* ── Overall Save button removed — each row saves via the grid ── */}

//                   <Button
//                     color="warning"
//                     variant="contained"
//                     onClick={() => navigate(-1)}
//                   >
//                     Cancel
//                   </Button>
//                 </Box>
//               </form>
//             );
//           }}
//         </Formik>

//         <FileListPopup
//           open={open}
//           onClose={() => setOpen(false)}
//           appId={recID}
//           empId={EMPID}
//         />
//       </Paper>

//       {/* ── Attachments table (IM mode) ── */}
//       {mode === "IM" && files.length > 0 && (
//         <Box mt={2}>
//           <Paper elevation={3} sx={{ padding: 2 }}>
//             <TableContainer component={Paper}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={rowSx}>
//                     <TableCell width={20}><strong>SL#</strong></TableCell>
//                     <TableCell><strong>Uploaded Date</strong></TableCell>
//                     <TableCell><strong>Filename</strong></TableCell>
//                     <TableCell><strong>Purpose</strong></TableCell>
//                     <TableCell><strong>Source</strong></TableCell>
//                     <TableCell><strong>View</strong></TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {files.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={6} align="center">
//                         No files uploaded yet.
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     files.map((file, index) => (
//                       <TableRow key={file.id || index} sx={rowSx}>
//                         <TableCell>{index + 1}</TableCell>
//                         <TableCell>{file.uploadedDate}</TableCell>
//                         <TableCell>{file.filename}</TableCell>
//                         <TableCell>{file.purpose}</TableCell>
//                         <TableCell>{file.source}</TableCell>
//                         <TableCell>
//                           <Tooltip title="Open File">
//                             <IconButton
//                               color="primary"
//                               component="a"
//                               href={file.url}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               size="small"
//                             >
//                               <OpenInNewIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Delete">
//                             <IconButton
//                               color="error"
//                               onClick={() =>
//                                 fileUpload(file.filename, EMPID, "delete", file.id, file.purpose)
//                               }
//                               size="small"
//                             >
//                               <DeleteForeverIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Paper>
//         </Box>
//       )}

//       {/* ── Occupied Hours Popup ── */}
//       <OccupiedHrsPopup
//         open={occupiedPopup.open}
//         onClose={() => setOccupiedPopup((prev) => ({ ...prev, open: false }))}
//         employeeName={occupiedPopup.employeeName}
//         employeeRole={occupiedPopup.employeeRole}
//         fromDate={occupiedPopup.fromDate}
//         toDate={occupiedPopup.toDate}
//         occupiedData={occupiedPopup.occupiedData}
//       />
//     </React.Fragment>
//   );
// };

// export default EditSprint;

//-------------------Navigation
// import {
//   TextField,
//   Box,
//   Checkbox,
//   useTheme,
//   Typography,
//   Button,
//   IconButton,
//   Tooltip,
//   Breadcrumbs,
//   LinearProgress,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Chip,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
// } from "@mui/material";
// import dayjs from "dayjs";
// import {
//   dataGridHeaderFooterHeight,
//   dataGridHeight,
//   dataGridRowHeight,
//   formGap,
// } from "../../../ui-components/global/utils";
// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
// import LaunchIcon from "@mui/icons-material/Launch";
// import axios from "axios";
// import store from "../../..";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
// import ResetTvIcon from "@mui/icons-material/ResetTv";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-hot-toast";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import FileListPopup from "../../../ui-components/FIleViewDialog";
// import FileUploadIconButton from "../../../ui-components/FileUploadButton";
// import { attachmentPost } from "../../../store/reducers/LoginReducer";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import {
//   postData,
//   sprintGetData,
//   sprintprojectplanGetData,
//   SprintOccupancy,
// } from "../../../store/reducers/Formapireducer";
// import React, { useState, useEffect, useRef } from "react";
// import Swal from "sweetalert2";
// import { useProSidebar } from "react-pro-sidebar";
// import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import { tokens } from "../../../Theme";
// import {
//   DataGrid,
//   GridToolbarContainer,
//   GridActionsCellItem,
//   GridRowModes,
// } from "@mui/x-data-grid";
// import SaveIcon from "@mui/icons-material/Save";
// import CancelIcon from "@mui/icons-material/Cancel";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import {
//   Productautocomplete,
//   SprintEmpAutocomplete,
// } from "../../../ui-components/global/Autocomplete";
// import { Formik } from "formik";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import SprintPDF from "../../reports/Sprintpdf";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import * as Yup from "yup";
// import { getConfig } from "../../../config";
// import sprintExcel from "../../reports/sprintExcel";
// import { FaFileExcel } from "react-icons/fa";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import BusinessIcon from "@mui/icons-material/Business";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
// import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
// import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
// import MiscellaneousServicesOutlinedIcon from "@mui/icons-material/MiscellaneousServicesOutlined";
// import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
// function toYMD(val) {
//   if (!val) return "";

//   // Already ISO / YYYY-MM-DD
//   if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}/.test(val)) {
//     return val.slice(0, 10);
//   }

//   // d/m/y or m/d/y slash format — treat as DD/MM/YYYY
//   if (typeof val === "string" && val.includes("/")) {
//     const parts = val.split("/");
//     if (parts.length === 3) {
//       // If first part is 4 digits it's YYYY/MM/DD
//       if (parts[0].length === 4) return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
//       // Otherwise assume DD/MM/YYYY
//       return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
//     }
//   }

//   // Fallback: let Date parse it
//   const d = new Date(val);
//   if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);

//   return "";
// }

// // ─── ItemTypePickerDialog ────────────────────────────────────────────────────
// function ItemTypePickerDialog({ open, onClose, onSelect }) {
//   const options = [
//     {
//       label: "Product",
//       show: "1",
//       icon: <Inventory2OutlinedIcon sx={{ color: "#26a69a" }} />,
//       description: "Add product items to this task",
//     },
//     {
//       label: "Material",
//       show: "2",
//       icon: <BuildOutlinedIcon sx={{ color: "#1976d2" }} />,
//       description: "Add material items to this task",
//     },
//     {
//       label: "Service",
//       show: "3",
//       icon: <MiscellaneousServicesOutlinedIcon sx={{ color: "#f57c00" }} />,
//       description: "Add service items to this task",
//     },
//     {
//       label: "Machinery",
//       show: "4",
//       icon: <PrecisionManufacturingOutlinedIcon sx={{ color: "#7b1fa2" }} />,
//       description: "Add machinery items to this task",
//     },
//   ];

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="xs"
//       fullWidth
//       PaperProps={{ sx: { borderRadius: "14px", overflow: "hidden" } }}
//     >
//       <Box
//         sx={{
//           background: "linear-gradient(135deg, #26a69a, #00796b)",
//           px: 3,
//           py: 2,
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//         }}
//       >
//         <AddBoxOutlinedIcon sx={{ color: "#fff" }} />
//         <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
//           Add Items to Task
//         </Typography>
//       </Box>

//       <DialogContent sx={{ p: 0, background: "#f7fafa" }}>
//         <Typography fontSize={13} color="text.secondary" sx={{ px: 3, pt: 2, pb: 1 }}>
//           Select an item type to add to this sprint task:
//         </Typography>
//         <List disablePadding>
//           {options.map((opt) => (
//             <ListItem key={opt.show} disablePadding divider>
//               <ListItemButton
//                 onClick={() => onSelect(opt.show)}
//                 sx={{ px: 3, py: 1.5, "&:hover": { background: "#e0f2f1" } }}
//               >
//                 <ListItemIcon sx={{ minWidth: 40 }}>{opt.icon}</ListItemIcon>
//                 <ListItemText
//                   primary={<Typography fontWeight={600} fontSize={14}>{opt.label}</Typography>}
//                   secondary={<Typography fontSize={12} color="text.secondary">{opt.description}</Typography>}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </DialogContent>

//       <DialogActions sx={{ background: "#fff", px: 3, py: 1.5 }}>
//         <Button variant="outlined" onClick={onClose} sx={{ borderRadius: "8px", textTransform: "none" }}>
//           Skip
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// // ─── OccupiedHrsPopup ────────────────────────────────────────────────────────
// function OccupiedHrsPopup({ open, onClose, employeeName, employeeRole, fromDate, toDate, occupiedData }) {
//   const grandTotal = occupiedData?.grandTotal || "0h";
//   const projects = occupiedData?.projects || [];

//   function formatDateToDDMMYYYY(dateStr) {
//     if (!dateStr) return "";
//     const [year, month, day] = dateStr.split("-");
//     if (!year || !month || !day) return dateStr;
//     return `${day}-${month}-${year}`;
//   }

//   const statusColor = (status) => {
//     if (status === "In progress") return { color: "#2e7d32", background: "#e8f5e9", border: "1px solid #a5d6a7" };
//     if (status === "Pending")    return { color: "#e65100", background: "#fff3e0", border: "1px solid #ffcc80" };
//     if (status === "Completed")  return { color: "#1565c0", background: "#e3f2fd", border: "1px solid #90caf9" };
//     return { color: "#555", background: "#f5f5f5", border: "1px solid #ddd" };
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}>
//       <Box sx={{ background: "linear-gradient(135deg, #4db6ac, #26a69a)", px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         <Box display="flex" alignItems="center" gap={1}>
//           <AccessTimeIcon sx={{ color: "#fff" }} />
//           <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>Occupied hours — {employeeName}</Typography>
//         </Box>
//       </Box>

//       <DialogContent sx={{ p: 0, background: "#f7fafa" }}>
//         <Box sx={{ background: "#e0f2f1", px: 3, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <Box display="flex" alignItems="center" gap={1}>
//             <PersonOutlineIcon sx={{ color: "#26a69a" }} />
//             <Typography fontWeight={700} color="#26a69a">{employeeName}</Typography>
//             <Typography color="text.secondary" fontSize={13}>{employeeRole}</Typography>
//           </Box>
//           <Chip label={`${grandTotal} occupied in range`} size="small" sx={{ background: "#b2dfdb", color: "#00695c", fontWeight: 600, fontSize: 12 }} />
//         </Box>

//         {fromDate && toDate && (
//           <Box sx={{ background: "#fffde7", px: 3, py: 1, display: "flex", alignItems: "center", gap: 1, borderBottom: "1px solid #f0f0f0" }}>
//             <CalendarTodayIcon sx={{ fontSize: 16, color: "#f9a825" }} />
//             <Typography fontSize={13} color="text.secondary">
//               Showing tasks for <strong>{formatDateToDDMMYYYY(fromDate)}</strong>
//               {toDate && toDate !== fromDate && <> to <strong>{formatDateToDDMMYYYY(toDate)}</strong></>}
//             </Typography>
//           </Box>
//         )}

//         <Box sx={{ px: 2, py: 1.5 }}>
//           {projects.length === 0 ? (
//             <Typography color="text.secondary" textAlign="center" py={3}>No tasks in this range.</Typography>
//           ) : (
//             projects.map((proj, pi) => (
//               <Box key={pi} sx={{ mb: 2, border: "1px solid #e0e0e0", borderRadius: "10px", overflow: "hidden" }}>
//                 <Box sx={{ background: "#fff", px: 2, py: 1, display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #e0e0e0" }}>
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <BusinessIcon sx={{ fontSize: 18, color: "#26a69a" }} />
//                     <Typography fontWeight={700} fontSize={14}>{proj.projectName}</Typography>
//                   </Box>
//                   <Box display="flex" alignItems="center" gap={0.5}>
//                     <PersonOutlineIcon sx={{ fontSize: 15, color: "#aaa" }} />
//                     <Typography fontSize={12} color="text.secondary">{proj.pm}</Typography>
//                   </Box>
//                 </Box>
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow sx={{ background: "#fafafa" }}>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888", width: 30 }}>#</TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888" }}>Task name</TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888", width: 100 }}>Date</TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#26a69a", textAlign: "center" }}>Hrs</TableCell>
//                       <TableCell sx={{ fontSize: 12, fontWeight: 600, color: "#888" }}>Status</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {proj.tasks.map((task, ti) => (
//                       <TableRow key={ti} sx={{ "&:nth-of-type(even)": { background: "#f9f9f9" } }}>
//                         <TableCell sx={{ fontSize: 12, color: "#aaa" }}>{ti + 1}</TableCell>
//                         <TableCell sx={{ fontSize: 13 }}>{task.name}</TableCell>
//                         <TableCell sx={{ fontSize: 12, color: "#555" }}>{task.from}</TableCell>
//                         <TableCell sx={{ fontSize: 13, color: "#26a69a", fontWeight: 700, textAlign: "center" }}>{task.hrs}</TableCell>
//                         <TableCell>
//                           <Box sx={{ display: "inline-block", px: 1, py: 0.3, borderRadius: "12px", fontSize: 11, fontWeight: 600, ...statusColor(task.status) }}>
//                             {task.status}
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                     <TableRow>
//                       <TableCell colSpan={4} align="right" sx={{ fontSize: 12, color: "#888", fontStyle: "italic" }}>Project total in range</TableCell>
//                       <TableCell sx={{ fontSize: 14, color: "#26a69a", fontWeight: 700, textAlign: "center" }}>{proj.projectTotal}</TableCell>
//                       <TableCell />
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </Box>
//             ))
//           )}
//         </Box>

//         <Box sx={{ px: 3, py: 1.5, display: "flex", justifyContent: "flex-end", borderTop: "1px solid #e0e0e0", background: "#fff" }}>
//           <Typography fontWeight={700} fontSize={14}>
//             Grand total: <span style={{ color: "#26a69a", fontSize: 16 }}>{grandTotal}</span>
//           </Typography>
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ background: "#fff", justifyContent: "flex-end", px: 3, py: 1.5 }}>
//         <Button variant="outlined" onClick={onClose} sx={{ borderRadius: "8px", textTransform: "none", minWidth: 80 }}>Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// // ─── Main Component ──────────────────────────────────────────────────────────
// const EditSprint = () => {
//   const isNonMobile = useMediaQuery("(min-width:600px)");
//   const navigate    = useNavigate();
//   const params      = useParams();
//   const dispatch    = useDispatch();
//   const location    = useLocation();
//   const state       = location.state || {};

//   const recID = params.id;
//   const mode  = params.Mode;

//   const getLoading        = useSelector((s) => s.formApi.sprintloading);
//   const SprintGEtdata     = useSelector((s) => s.formApi.sprintget) || {};
//   const listViewurl       = useSelector((s) => s.globalurl.listViewurl);
//   const sprintPPgetloading = useSelector((s) => s.formApi.sprintloading);

//   const CompanyAutoCode   = sessionStorage.getItem("CompanyAutoCode");
//   const CompanyID         = sessionStorage.getItem("companyId");
//   const EMPID             = sessionStorage.getItem("EmpId");
//   const HeaderImg         = sessionStorage.getItem("CompanyHeader");
//   const FooterImg         = sessionStorage.getItem("CompanyFooter");
//   const SubscriptionCode  = sessionStorage.getItem("SubscriptionCode") || "";
//   const is002Subscription = SubscriptionCode.endsWith("002");

//   const { toggleSidebar, broken, rtl } = useProSidebar();
//   const theme  = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const config  = getConfig();
//   const baseurl1 = config.UAAM_URL;

//   const [files, setFiles]           = useState([]);
//   const [page, setPage]             = useState(0);
//   const [pageSize, setPageSize]     = useState(15);
//   const [loading, setLoading]       = useState(false);
//   const [error, setError]           = useState("");
//   const [showImage, setShowImage]   = useState(mode === "IM");
//   const [errorMsgData, setErrorMsgData]       = useState(null);
//   const [validationSchema, setValidationSchema] = useState(null);
//   const [rowModesModel, setRowModesModel]       = useState({});
//   const [funMode, setFunMode]       = useState(mode);
//   const [open, setOpen]             = useState(false);
//   const [rows, setRows]             = useState([]);
//   const [rowCount, setRowCount]     = useState(0);
//   const [occupiedLoading, setOccupiedLoading] = useState(false);
//   const [occupiedPopup, setOccupiedPopup]     = useState({
//     open: false, employeeName: "", employeeRole: "",
//     fromDate: "", toDate: "", occupiedData: null,
//   });
//   const [itemPicker, setItemPicker] = useState({ open: false, dailyTaskID: null });

//   const formikValuesRef = useRef({});
//   const rowSx = { height: 36, "& td, & th": { py: 0.5 } };

//   // ── validation schema ──────────────────────────────────────────────────────
//   useEffect(() => {
//     fetch(process.env.PUBLIC_URL + "/validationcms.json")
//       .then((res) => { if (!res.ok) throw new Error("Failed"); return res.json(); })
//       .then((data) => {
//         setErrorMsgData(data);
//         const fields = {};
//         if (CompanyAutoCode === "N") fields.code = Yup.string().required(data.Routinetask.code);
//         setValidationSchema(Yup.object().shape(fields));
//       })
//       .catch((err) => console.error(err));
//   }, [CompanyAutoCode]);

//   // ── initial data load ──────────────────────────────────────────────────────
//   useEffect(() => {
//     GetSprintData();
//     const url = store.getState().globalurl.empGetAttachmentUrl;
//     axios
//       .get(url, { params: { empId: EMPID, appId: recID } })
//       .then((res) => setFiles(res.data))
//       .catch((err) => { setError("Failed to fetch attachments."); console.error(err); })
//       .finally(() => setLoading(false));
//   }, [location.key]);

//   // ── GetSprintData — called on mount and after every save / delete ──────────
//   async function GetSprintData() {
//     const res = await dispatch(sprintGetData({ SprintHeaderID: recID }));
//     if (res.payload.Status === "Y") {
//       const resData = res.payload.Data.detailData.map((value) => ({
//         ...value,
//         // Normalise date to YYYY-MM-DD so the date column never flips to d/m/y
//         ScheduledDate: toYMD(value.ScheduledDate),
//         ProjectPlanDate: toYMD(value.ProjectPlanDate),
//         CompletedDate: toYMD(value.CompletedDate),
//         ScheduledTo: {
//           EmployeeID: value.ScheduledTo,
//           RecordID: value.ScheduledTo,
//           Name: value.EmployeeName,
//         },
//         // OccupiedHrs may come from the server; keep it as-is
//       }));
//       setRows(resData);
//     } else {
//       setRows([]);
//     }
//   }

//   // ── Formik initial values ──────────────────────────────────────────────────
//   const InitialValue = {
//     code: SprintGEtdata.Code || "",
//     name: SprintGEtdata.Name || "",
//     Milestone: SprintGEtdata.MilestoneID
//       ? { RecordID: SprintGEtdata.MilestoneID, Name: SprintGEtdata.MilestoneName }
//       : "",
//     OperationStage: SprintGEtdata.OperationStageID
//       ? { RecordID: SprintGEtdata.OperationStageID, Name: SprintGEtdata.OperationName }
//       : null,
//     Activities: SprintGEtdata.ActivitiesID
//       ? { RecordID: SprintGEtdata.ActivitiesID, Name: SprintGEtdata.ActivitiesName }
//       : null,
//     fromdate: SprintGEtdata.FromDate || "",
//     todate:   SprintGEtdata.ToDate   || "",
//     checkbox: SprintGEtdata.BackLog === "Y",
//   };

//   // ── handleApply ────────────────────────────────────────────────────────────
//   const handleApply = async (values) => {
//     const data = await dispatch(
//       sprintprojectplanGetData({
//         ActivitiesID: values.Activities ? values.Activities.RecordID : 0,
//         FromDate: values.fromdate,
//         ToDate:   values.todate,
//         BackLog:  values.checkbox ? "Y" : "N",
//       })
//     );
//     if (data.payload.Status === "Y") {
//       setRows(
//         data.payload.Data.map((row) => ({
//           ...row,
//           ScheduledDate: toYMD(row.ScheduledDate),
//           ProjectPlanDate: toYMD(row.ProjectPlanDate),
//           ScheduledTo: row.ScheduledTo
//             ? { EmployeeID: row.ScheduledTo, Name: row.EmployeeName }
//             : null,
//         }))
//       );
//     } else {
//       setRows([]);
//     }
//   };

//   // ── saveRowToApi ───────────────────────────────────────────────────────────
//   const saveRowToApi = async (newRow) => {
//     const values = formikValuesRef.current;

//     if (!newRow.ScheduledTo?.EmployeeID) throw new Error("Scheduled To is required.");

//     const idata = {
//       RecordID: recID,
//       Code:     values.code || "",
//       Name:     values.name || "",
//       MilestoneID:       values.Milestone      ? values.Milestone.RecordID      : 0,
//       MilestoneName:     values.Milestone      ? values.Milestone.Name          : "",
//       OperationStageID:  values.OperationStage ? values.OperationStage.RecordID : 0,
//       OperationStageName:values.OperationStage ? values.OperationStage.Name     : "",
//       ActivitiesID:      values.Activities     ? values.Activities.RecordID     : 0,
//       ActivitiesName:    values.Activities     ? values.Activities.Name         : "",
//       FromDate:  values.fromdate || "",
//       ToDate:    values.todate   || "",
//       ProjectID: params.filtertype,
//       LoginUser: EMPID,
//       BackLog:   values.checkbox ? "Y" : "N",
//       Details: [{
//         Task:           newRow.Task           || "",
//         RoleID:         newRow.RoleID         || "",
//         Effort:         newRow.Effort         || "",
//         ProjectPlanDate:newRow.ProjectPlanDate|| "",
//         ScheduledDate:  newRow.ScheduledDate  || "",
//         CompletedDate:  newRow.CompletedDate  || "",
//         ScheduledTo:    newRow.ScheduledTo?.EmployeeID || "0",
//         TaskDetailID:   newRow.RecordID       || "",
//         Status:         newRow.Status         || "SH",
//         Comments:       newRow.Comments       || "",
//       }],
//     };

//     const response = await dispatch(
//       postData({ accessID: "TR262", action: mode === "A" ? "insert" : "update", idata })
//     );

//     if (response.payload.Status === "Y") {
//       toast.success(response.payload.Msg);

//       const dailyTaskID =
//         response.payload.DailyTaskID ||
//         response.payload.Data?.DailyTaskID ||
//         (Array.isArray(response.payload.Data) && response.payload.Data[0]?.DailyTaskID) ||
//         null;

//       return { dailyTaskID };
//     } else {
//       throw new Error(response.payload.Msg || response.payload.Data || "Save failed.");
//     }
//   };

//   // ── processRowUpdate ───────────────────────────────────────────────────────
//   // After a successful save we:
//   //   1. Call GetSprintData() to get fresh, correctly-formatted rows from the server.
//   //   2. Open the ItemTypePicker (for 002 subscriptions).
//   //   3. Return newRow so DataGrid doesn't stay in edit mode.
//   const processRowUpdate = async (newRow) => {
//     try {
//       const { dailyTaskID } = await saveRowToApi(newRow);

//       // Refresh all rows from the server (fixes date format, statuses, etc.)
//       await GetSprintData();

//       // Stamp DailyTaskID so "Add Items" icon can use it after refresh
//       if (dailyTaskID) {
//         setRows((prev) =>
//           prev.map((row) =>
//             row.RecordID === newRow.RecordID ? { ...row, DailyTaskID: dailyTaskID } : row
//           )
//         );
//       }

//       // if (is002Subscription) {
//       //   setItemPicker({ open: true, dailyTaskID });
//       // }

//       return { ...newRow, isNew: false, isUpdated: false, DailyTaskID: dailyTaskID };
//     } catch (err) {
//       console.error("❌ Row save failed:", err);
//       toast.error(err.message || "Error occurred during save.");
//       throw err;
//     }
//   };

//   const handleProcessRowUpdateError = (err) => console.error("processRowUpdateError:", err);

//   // ── handleItemTypeSelect ───────────────────────────────────────────────────
//   const handleItemTypeSelect = (showValue) => {
//     const taskID = itemPicker.dailyTaskID;
//     setItemPicker({ open: false, dailyTaskID: null });
//     navigate(`/Apps/TR132/Scrum%20Task/EditScrum%20Task/${taskID || 73036}/E`, {
//       state: { initialShow: showValue },
//     });
//   };

//   // ── Grid action handlers ───────────────────────────────────────────────────
//   const handleEditClick   = (id) => () => {
//     setFunMode("E");
//     setRowModesModel((prev) => ({ ...prev, [id]: { mode: GridRowModes.Edit } }));
//   };
//   const handleSave        = (id) => () =>
//     setRowModesModel((prev) => ({ ...prev, [id]: { mode: GridRowModes.View } }));
//   const handleCancelClick = (id) => () =>
//     setRowModesModel((prev) => ({ ...prev, [id]: { mode: GridRowModes.View, ignoreModifications: true } }));
//   const handleRowModesModelChange = (m) => setRowModesModel(m);

//   // ── DELETE — calls API hardDelete then refreshes ───────────────────────────
//   const handleDeleteClick = (id) => async () => {
//     const row = rows.find((r) => r.RecordID === id);
//     if (!row) return;

//     Swal.fire({
//       title: "Are you sure you want to delete?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Delete",
//     }).then(async (result) => {
//       if (!result.isConfirmed) return;

//       try {
//         const values = formikValuesRef.current;

//         const idata = {
//           RecordID: recID,
//           Code:     values.code || "",
//           Name:     values.name || "",
//           MilestoneID:        values.Milestone      ? values.Milestone.RecordID      : 0,
//           MilestoneName:      values.Milestone      ? values.Milestone.Name          : "",
//           OperationStageID:   values.OperationStage ? values.OperationStage.RecordID : 0,
//           OperationStageName: values.OperationStage ? values.OperationStage.Name     : "",
//           ActivitiesID:       values.Activities     ? values.Activities.RecordID     : 0,
//           ActivitiesName:     values.Activities     ? values.Activities.Name         : "",
//           FromDate:  values.fromdate || "",
//           ToDate:    values.todate   || "",
//           ProjectID: params.filtertype,
//           LoginUser: EMPID,
//           BackLog:   values.checkbox ? "Y" : "N",
//           Details: [{
//             Task:           row.Task           || "",
//             RoleID:         row.RoleID         || "",
//             Effort:         row.Effort         || "",
//             ProjectPlanDate:row.ProjectPlanDate|| "",
//             ScheduledDate:  row.ScheduledDate  || "",
//             CompletedDate:  row.CompletedDate  || "",
//             ScheduledTo:    row.ScheduledTo?.EmployeeID || "0",
//             TaskDetailID:   row.RecordID       || "",
//             Status:         row.Status         || "SH",
//             Comments:       row.Comments       || "",
//           }],
//         };

//         const response = await dispatch(
//           postData({ accessID: "TR262", action: "harddelete", idata })
//         );

//         if (response.payload.Status === "Y") {
//           toast.success(response.payload.Msg || "Deleted successfully.");
//           // Refresh from server after delete
//           await GetSprintData();
//         } else {
//           toast.error(response.payload.Msg || "Delete failed.");
//         }
//       } catch (err) {
//         console.error("Delete error:", err);
//         toast.error("Error occurred during delete.");
//       }
//     });
//   };

//   // ── handleOpenItemPickerForRow ─────────────────────────────────────────────
//   const handleOpenItemPickerForRow = (row) => {
//     const taskID = row.DailyTaskID || null;
//     if (!taskID) { toast.error("Save the row first before adding items."); return; }
//     setItemPicker({ open: true, dailyTaskID: taskID });
//   };

//   // ── Occupied popup ─────────────────────────────────────────────────────────
//   /**
//    * Opens the occupied-hours popup for a row.
//    * Works whether OccupiedHrs came from the API (after GET) OR was set locally
//    * when the user selected an employee in the autocomplete cell.
//    * Requires both ScheduledTo and ScheduledDate on the row.
//    */
//   const handleOpenOccupied = async (row) => {
//     const employeeID = row.ScheduledTo?.EmployeeID || row.EmployeeID || "";
//     const taskDate   = toYMD(row.ScheduledDate) || "";

//     if (!employeeID) { toast.error("No employee assigned to this row."); return; }
//     if (!taskDate)   { toast.error("Please set a Scheduled Date first."); return; }

//     setOccupiedLoading(true);
//     setOccupiedPopup({
//       open: true,
//       employeeName: row.ScheduledTo?.Name || row.EmployeeName || "",
//       employeeRole: row.DesignationsName  || "",
//       fromDate: taskDate,
//       toDate:   taskDate,
//       occupiedData: null, // show loading state in popup
//     });

//     try {
//       const res = await dispatch(
//         SprintOccupancy({ EmployeeID: String(employeeID), SprintDate: taskDate })
//       );
//       const payload = res?.payload;

//       if (payload?.Status === "Y") {
//         const emp        = payload.Employee || {};
//         const grandTotal = `${payload.RangeTotalHours ?? emp.OverallOccupied ?? 0}h`;
//         const projects   = (payload.Projects || []).map((proj) => ({
//           projectName:  proj.ProjectName,
//           pm:           proj.InchargeName || "",
//           projectTotal: `${proj.SubtotalHours ?? 0}h`,
//           tasks: (proj.Tasks || []).map((t) => ({
//             name:   t.TaskName,
//             from:   t.TaskDate,
//             to:     t.TaskDate,
//             hrs:    `${t.EstHours}h`,
//             status: t.Status || "—",
//           })),
//         }));

//         setOccupiedPopup((prev) => ({
//           ...prev,
//           employeeRole: emp.Designation || row.DesignationsName || "",
//           occupiedData: { grandTotal, projects },
//         }));
//       } else {
//         setOccupiedPopup((prev) => ({
//           ...prev,
//           occupiedData: { grandTotal: "0h", projects: [] },
//         }));
//       }
//     } catch (err) {
//       console.error("SprintOccupancy error:", err);
//       setOccupiedPopup((prev) => ({ ...prev, occupiedData: { grandTotal: "0h", projects: [] } }));
//     } finally {
//       setOccupiedLoading(false);
//     }
//   };

//   /**
//    * Returns display info for the OccupiedHrs cell.
//    * Shows whenever OccupiedHrs > 0, regardless of whether it came from
//    * the server response or was set locally when the employee was selected.
//    */
//   const getOccupiedLabel = (row) => {
//     const empName = row.ScheduledTo?.Name || row.EmployeeName || "";
//     if (!empName) return null;
//     const rawHrs = parseFloat(row.OccupiedHrs);
//     if (isNaN(rawHrs) || rawHrs <= 0) return null;
//     return { label: `${rawHrs}h`, isOverloaded: rawHrs > 40 };
//   };

//   // ── Logout / Close ─────────────────────────────────────────────────────────
//   const fnLogOut = (props) => {
//     Swal.fire({
//       title: errorMsgData?.Warningmsg?.[props] || `Are you sure you want to ${props}?`,
//       icon: "warning", showCancelButton: true,
//       confirmButtonColor: "#3085d6", cancelButtonColor: "#d33",
//       confirmButtonText: props,
//     }).then((result) => {
//       if (result.isConfirmed) {
//         if (props === "Logout") navigate("/");
//         if (props === "Close")  navigate(-1);
//       }
//     });
//   };

//   // ── Toolbar ────────────────────────────────────────────────────────────────
//   function Custombar() {
//     return (
//       <GridToolbarContainer sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
//         <Box sx={{ display: "flex", flexDirection: "row" }}>
//           <Typography>List of Sprint Task</Typography>
//           <Typography variant="h5">{`(${rowCount})`}</Typography>
//         </Box>
//       </GridToolbarContainer>
//     );
//   }

//   // ── EditAutocompleteCell ───────────────────────────────────────────────────
//   // When an employee is selected we immediately store OccupiedHrs locally so
//   // the chip appears without needing to wait for the API GET.
//   function EditAutocompleteCell(props) {
//     const { id, field, api, row } = props;
//     const [Employee, setEmployee] = useState(row.ScheduledTo ?? null);

//     const handleChange = async (newValue) => {
//       if (!newValue) return;
//       setEmployee(newValue);
//       await api.setEditCellValue({ id, field: "ScheduledTo", value: newValue });

//       // Persist OccupiedHrs locally from the autocomplete option so the chip
//       // renders immediately (before the row is saved and GET is called).
//       setRows((prev) =>
//         prev.map((r) =>
//           r.RecordID === row.RecordID
//             ? {
//                 ...r,
//                 ScheduledTo: newValue,
//                 OccupiedHrs:
//                   newValue.OccupiedHrs !== undefined
//                     ? newValue.OccupiedHrs
//                     : r.OccupiedHrs,
//               }
//             : r
//         )
//       );

//       api.stopCellEditMode({ id, field });
//     };

//     return (
//       <SprintEmpAutocomplete
//         name="ScheduledTo"
//         label="ScheduledTo"
//         id="ScheduledTo"
//         value={Employee}
//         onChange={handleChange}
//         url={`${listViewurl}?data={"Query":{"AccessID":"2109","ScreenName":"Scheduled To","Filter":"DesignationID='${row.RoleID}' AND ProjectID='${state.projectID || params.filtertype}'","Any":""}}`}
//       />
//     );
//   }

//   // ── EditDateCell ───────────────────────────────────────────────────────────
//   // Always uses YYYY-MM-DD for the <input type="date"> value so the browser
//   // never reformats the saved date to d/m/y.
//   function EditDateCell(props) {
//     const { id, field, value, api } = props;

//     const handleChange = (e) => {
//       api.setEditCellValue({ id, field, value: e.target.value }); // already YYYY-MM-DD from input
//     };

//     return (
//       <TextField
//         type="date"
//         fullWidth
//         size="small"
//         value={toYMD(value)}
//         onChange={handleChange}
//         InputLabelProps={{ shrink: true }}
//       />
//     );
//   }

//   // ── Grid columns ───────────────────────────────────────────────────────────
//   const Sprintcolumns = [
//     {
//       field: "slno",
//       headerName: "SL#",
//       width: 60,
//       sortable: false, filterable: false, disableColumnMenu: true,
//       valueGetter: (params) => {
//         const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
//         const totalVisible = params.api.getAllRowIds().length;
//         const totalAll     = params.api.getRowsCount();
//         return totalVisible < totalAll ? index + 1 : page * pageSize + index + 1;
//       },
//     },
//     { headerName: "Task",             field: "Task",            width: 250, align: "left",  headerAlign: "center", editable: false },
//     { headerName: "Role",             field: "DesignationsName",width: 200, align: "left",  headerAlign: "center", editable: false },
//     { headerName: "Effort",           field: "Effort",          width: 100, align: "right", headerAlign: "center", editable: false },
//     {
//       headerName: "Project Plan Date",
//       field: "ProjectPlanDate",
//       width: 150,
//       align: "left", headerAlign: "center",
//       editable: false,
//       // Render normalised so it never flips to browser locale format
//       renderCell: (p) => toYMD(p.value) || "",
//     },
//     {
//       headerName: "Scheduled Date",
//       field: "ScheduledDate",
//       width: 130,
//       editable: true,
//       // Always show in YYYY-MM-DD so it never displays as d/m/y
//       renderCell: (p) => toYMD(p.value) || "",
//       renderEditCell: (p) => <EditDateCell {...p} />,
//     },
//     {
//       field: "ScheduledTo",
//       headerName: (
//         <span>Scheduled To <span style={{ color: "red" }}>*</span></span>
//       ),
//       width: 160,
//       align: "left", headerAlign: "center",
//       editable: true, sortable: false,
//       renderCell:     (p) => p.value?.Name || "",
//       renderEditCell: (p) => <EditAutocompleteCell {...p} />,
//     },
//     {
//       field: "OccupiedHours",
//       headerName: "Occupied Hrs",
//       width: 160,
//       align: "left", headerAlign: "center",
//       editable: false, sortable: false,
//       renderCell: (params) => {
//         const info = getOccupiedLabel(params.row);
//         // Show the chip as soon as OccupiedHrs is set (locally or from API)
//         if (!info) return null;

//         const canOpen =
//           (params.row.ScheduledTo?.EmployeeID || params.row.EmployeeID) &&
//           toYMD(params.row.ScheduledDate);

//         return (
//          <Box
//             onClick={() =>
//               handleOpenOccupied(
//                 params.row              
//               )
//             }
//             sx={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 0.5,
//               cursor: "pointer",
//             }}
//           >
//             <Typography sx={{ fontSize: 13}}>
//               {info.label} occupied
//             </Typography>

//             <LaunchIcon sx={{ fontSize: 15 }} />
//           </Box>
//         );
//       },
//     },
//     ...(mode === "E"
//       ? [{
//           headerName: "Completed Date",
//           field: "CompletedDate",
//           width: 150, editable: false,
//           renderCell: (p) => toYMD(p.value) || "",
//         }]
//       : []),
//     { headerName: "Comments", field: "Comments", width: 220, editable: true },
//     { headerName: "Status",   field: "Status",   width: 100, align: "left", headerAlign: "center", editable: false },
//     {
//       field: "actions",
//       type: "actions",
//       headerName: "Actions",
//       width: 160,
//       cellClassName: "actions",
//       getActions: (params) => {
//         const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

//         if (isInEditMode) {
//           return [
//             <GridActionsCellItem icon={<SaveIcon />}   label="Save"   sx={{ color: "#009688" }} onClick={handleSave(params.id)} />,
//             <GridActionsCellItem icon={<CancelIcon />} label="Cancel" onClick={handleCancelClick(params.id)} color="inherit" />,
//           ];
//         }

//         const rowStatus = params.row.Status;
//         const hasValidStatus =
//           rowStatus !== null && rowStatus !== undefined && rowStatus.toString().trim() !== "";

//         const actions = [
//           <GridActionsCellItem icon={<EditIcon   style={{ color: "#3498db" }} />} label="Edit"   onClick={handleEditClick(params.id)}   color="inherit" />,
//           <GridActionsCellItem icon={<DeleteIcon style={{ color: "#e74c3c" }} />} label="Delete" onClick={handleDeleteClick(params.id)} color="inherit" />,
//         ];

//         if (hasValidStatus && is002Subscription) {
//           actions.push(
//             <GridActionsCellItem
//               icon={
//                   <Tooltip title="Add Product / Material / Service / Machinery">              
//                   <AddBoxOutlinedIcon style={{ color: "#7b1fa2" }} />
//                 </Tooltip>
//               }
//               label="Add Items"
//               onClick={() => handleOpenItemPickerForRow(params.row)}
//               color="inherit"
//               showInMenu={false}
//             />
//           );
//         }

//         return actions;
//       },
//     },
//   ];

//   // ── file upload ────────────────────────────────────────────────────────────
//   async function fileUpload(file, empId, action, id, purpose) {
//     const formData = new FormData();
//     formData.append("file",    file);
//     formData.append("empId",   empId);
//     formData.append("appId",   recID);
//     formData.append("type",    "SP");
//     formData.append("source",  "Sprint");
//     formData.append("action",  action);
//     formData.append("id",      id);
//     formData.append("purpose", purpose || "");

//     const respose = await dispatch(attachmentPost({ data: formData }));
//     if (respose.payload.success) {
//       toast.success(respose.payload.message);
//       const url = store.getState().globalurl.empGetAttachmentUrl;
//       axios.get(url, { params: { empId: EMPID, appId: recID } })
//         .then((res) => setFiles(res.data))
//         .catch((err) => { setError("Failed to fetch attachments."); console.error(err); })
//         .finally(() => setLoading(false));
//     } else {
//       toast.error(respose.payload.message);
//     }
//   }

//   // ── render ─────────────────────────────────────────────────────────────────
//   return (
//     <React.Fragment>
//       {getLoading && <LinearProgress />}

//       {/* Header bar */}
//       <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
//         <Box display="flex" justifyContent="space-between">
//           <Box display="flex" borderRadius="3px" alignItems="center">
//             {broken && !rtl && (
//               <IconButton onClick={() => toggleSidebar()}><MenuOutlinedIcon /></IconButton>
//             )}
//             <Breadcrumbs maxItems={1} aria-label="breadcrumb" separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}>
//               <Typography variant="h5" color="#0000D1" sx={{ cursor: "default", marginLeft: "10px" }} onClick={() => navigate(-1)}>
//                 Sprint
//               </Typography>
//             </Breadcrumbs>
//           </Box>
//           <Box display="flex">
//             <Tooltip title="Close">
//               <IconButton onClick={() => fnLogOut("Close")} color="error"><ResetTvIcon /></IconButton>
//             </Tooltip>
//             <Tooltip title="Logout">
//               <IconButton color="error" onClick={() => fnLogOut("Logout")}><LogoutOutlinedIcon /></IconButton>
//             </Tooltip>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Form */}
//       <Paper elevation={3} sx={{ margin: "10px" }}>
//         {mode === "IM" && (
//           <Box display="flex" padding={1} justifyContent="flex-end" mt="2px" gridColumn="span 4" gap={2} marginBottom={-5}>
//             <IconButton onClick={() => setShowImage((prev) => !prev)} sx={{ padding: "12px" }}>
//               <ArrowDownwardIcon sx={{ color: "blue", marginBottom: "8px" }} />
//             </IconButton>
//           </Box>
//         )}

//         <Formik
//           initialValues={InitialValue}
//           onSubmit={(values) => { setTimeout(() => handleApply(values), 100); }}
//           enableReinitialize
//           validationSchema={validationSchema}
//         >
//           {({ errors, touched, handleBlur, handleChange, values, handleSubmit, setFieldValue }) => {
//             formikValuesRef.current = values;
//             return (
//               <form onSubmit={handleSubmit}>
//                 <Box
//                   display="grid" gap={formGap} padding={1}
//                   gridTemplateColumns="repeat(2, minMax(0,1fr))"
//                   sx={{ "& > div": { gridColumn: isNonMobile ? undefined : "span 2" } }}
//                 >
//                   {/* Code */}
//                   {CompanyAutoCode === "Y" ? (
//                     <TextField name="code" type="text" id="code" label="Code" variant="standard" placeholder="Auto"
//                       focused value={values.code} onBlur={handleBlur} onChange={handleChange}
//                       error={!!touched.code && !!errors.code} helperText={touched.code && errors.code}
//                       InputProps={{ readOnly: true }} />
//                   ) : (
//                     <TextField name="code" type="text" id="code"
//                       label={<>Code <span style={{ color: "red", fontSize: "20px" }}> * </span></>}
//                       variant="standard" focused value={values.code} onBlur={handleBlur} onChange={handleChange}
//                       error={!!touched.code && !!errors.code} helperText={touched.code && errors.code} autoFocus />
//                   )}

//                   {/* Description */}
//                   <TextField name="name" type="text" id="name" label="Description" variant="standard" focused
//                     value={values.name} onBlur={handleBlur} onChange={handleChange}
//                     error={!!touched.name && !!errors.name} helperText={touched.name && errors.name}
//                     autoFocus={CompanyAutoCode === "Y"} />

//                   {!showImage && (
//                     <React.Fragment>
//                       <TextField name="fromdate" type="date" id="fromdate" label="From Date" variant="standard" focused
//                         value={values.fromdate} onBlur={handleBlur} onChange={handleChange}
//                         error={!!touched.fromdate && !!errors.fromdate} helperText={touched.fromdate && errors.fromdate}
//                         InputLabelProps={{ shrink: true }} />

//                       <TextField name="todate" type="date" id="todate" label="To Date" variant="standard" focused
//                         value={values.todate} onBlur={handleBlur} onChange={handleChange}
//                         error={!!touched.todate && !!errors.todate} helperText={touched.todate && errors.todate}
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{ inputProps: {
//                           min: values.fromdate || undefined,
//                           max: values.fromdate ? dayjs(values.fromdate).add(6, "day").format("YYYY-MM-DD") : undefined,
//                         }}} />

//                       <Productautocomplete sx={{ marginTop: "7px" }} name="Milestone" label="Milestone"
//                         variant="outlined" id="Milestone" value={values.Milestone}
//                         getOptionLabel={(option) => option?.Name || ""}
//                         onChange={(newValue) => setFieldValue("Milestone", newValue)}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"ParentID=${params.filtertype} AND CompanyID=${CompanyID}","Any":""}}`} />

//                       <Productautocomplete sx={{ marginTop: "7px" }} name="OperationStage" label="Operation Stage"
//                         variant="outlined" id="OperationStage" value={values.OperationStage}
//                         onChange={(newValue) => setFieldValue("OperationStage", newValue)}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID=${values.Milestone ? values.Milestone.RecordID : 0}","Any":""}}`} />

//                       <Productautocomplete name="Activities" label="Activities" variant="outlined" id="Activities"
//                         value={values.Activities}
//                         onChange={(newValue) => setFieldValue("Activities", newValue)}
//                         url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID=${values.OperationStage ? values.OperationStage.RecordID : 0}","Any":""}}`} />
//                     </React.Fragment>
//                   )}

//                   {!showImage && (
//                     <React.Fragment>
//                       <Box display="flex" justifyContent="end" padding={1} gap={2}>
//                         {mode === "A" && (
//                           <Checkbox name="checkbox" checked={values.checkbox}
//                             onChange={(e) => {
//                               handleChange(e);
//                               setTimeout(() => handleApply({ ...values, checkbox: e.target.checked }), 0);
//                             }} />
//                         )}
//                         {mode === "A" && (
//                           <Button color="secondary" variant="contained" type="submit"
//                             loading={sprintPPgetloading} onClick={() => handleApply(values)}>
//                             Apply
//                           </Button>
//                         )}

//                         <PDFDownloadLink
//                           document={
//                             <SprintPDF key={rows} data={rows} filters={{
//                               Code: values.code, Description: values.name,
//                               FromDate: values.fromdate, ToDate: values.todate,
//                               Milestone: values.Milestone?.Name || "",
//                               Stages: values.OperationStage?.Name || "",
//                               Activities: values.Activities?.Name || "",
//                               Imageurl: baseurl1, HeaderImg, FooterImg,
//                             }} />
//                           }
//                           fileName="Sprint.pdf"
//                           style={{ color: "#d32f2f", cursor: "pointer" }}
//                         >
//                           {({ loading: pdfLoading }) =>
//                             pdfLoading
//                               ? <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
//                               : <PictureAsPdfIcon sx={{ fontSize: 24 }} />
//                           }
//                         </PDFDownloadLink>

//                         <FaFileExcel size={20} color="#1D6F42" style={{ cursor: "pointer" }}
//                           onClick={() => sprintExcel(rows, {
//                             Code: values.code, Description: values.name,
//                             FromDate: values.fromdate, ToDate: values.todate,
//                             Milestone: values.Milestone?.Name || "",
//                             Stages: values.OperationStage?.Name || "",
//                             Activities: values.Activities?.Name || "",
//                           })} />
//                       </Box>
//                     </React.Fragment>
//                   )}
//                 </Box>

//                 {/* DataGrid */}
//                 {!getLoading && !showImage && (
//                   <Box m="5px">
//                     <Box m="5px 0 0 0" height={dataGridHeight} sx={{
//                       "& .MuiDataGrid-root":          { border: "none" },
//                       "& .MuiDataGrid-cell":          { borderBottom: "none" },
//                       "& .name-column--cell":         { color: colors.greenAccent[300] },
//                       "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[800], borderBottom: "none" },
//                       "& .MuiDataGrid-virtualScroller":{ backgroundColor: colors.primary[400] },
//                       "& .MuiDataGrid-footerContainer":{ borderTop: "none", backgroundColor: colors.blueAccent[800] },
//                       "& .MuiCheckbox-root":          { color: `${colors.greenAccent[200]} !important` },
//                       "& .odd-row":  { backgroundColor: "" },
//                       "& .even-row": { backgroundColor: "#D3D3D3" },
//                     }}>
//                       <DataGrid
//                         sx={{ "& .MuiDataGrid-footerContainer": { height: dataGridHeaderFooterHeight, minHeight: dataGridHeaderFooterHeight } }}
//                         rows={rows}
//                         columns={Sprintcolumns}
//                         loading={sprintPPgetloading}
//                         rowModesModel={rowModesModel}
//                         getRowId={(row) => row.RecordID}
//                         editMode="cell"
//                         pageSize={pageSize}
//                         page={page}
//                         onPageSizeChange={(n) => setPageSize(n)}
//                         onPageChange={(n) => setPage(n)}
//                         disableRowSelectionOnClick
//                         rowHeight={dataGridRowHeight}
//                         headerHeight={dataGridHeaderFooterHeight}
//                         experimentalFeatures={{ newEditingApi: true }}
//                         onRowModesModelChange={handleRowModesModelChange}
//                         processRowUpdate={processRowUpdate}
//                         onProcessRowUpdateError={handleProcessRowUpdateError}
//                         onStateChange={(s) => setRowCount(s.pagination.rowCount)}
//                         components={{ Toolbar: Custombar }}
//                         componentsProps={{ toolbar: { setRows, setRowModesModel } }}
//                         rowsPerPageOptions={[5, 10, 20]}
//                         getRowClassName={(p) =>
//                           p.indexRelativeToCurrentPage % 2 === 0 ? "odd-row" : "even-row"
//                         }
//                         pagination
//                       />
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Bottom bar */}
//                 <Box display="flex" justifyContent="end" padding={1} gap="20px">
//                   {mode === "IM" && (
//                     <>
//                       <TextField name="purpose" type="text" id="purpose" label="Purpose" variant="standard"
//                         focused value={values.purpose} onBlur={handleBlur} onChange={handleChange}
//                         error={!!touched.purpose && !!errors.purpose} helperText={touched.purpose && errors.purpose}
//                         sx={{ gridColumn: "span 2", height: "20px", marginBottom: "5px" }}
//                         InputLabelProps={{ shrink: true }} />
//                       <Box display="flex" alignItems="center" gap={1}>
//                         <FileUploadIconButton
//                           onFileSelect={(file) => {
//                             fileUpload(file, EMPID, "upload", "", values.purpose);
//                             setFieldValue("purpose", "");
//                           }}
//                         />
//                       </Box>
//                     </>
//                   )}
//                   <Button color="warning" variant="contained" onClick={() => navigate(-1)}>Cancel</Button>
//                 </Box>
//               </form>
//             );
//           }}
//         </Formik>

//         <FileListPopup open={open} onClose={() => setOpen(false)} appId={recID} empId={EMPID} />
//       </Paper>

//       {/* Attachments (IM mode) */}
//       {mode === "IM" && files.length > 0 && (
//         <Box mt={2}>
//           <Paper elevation={3} sx={{ padding: 2 }}>
//             <TableContainer component={Paper}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={rowSx}>
//                     <TableCell width={20}><strong>SL#</strong></TableCell>
//                     <TableCell><strong>Uploaded Date</strong></TableCell>
//                     <TableCell><strong>Filename</strong></TableCell>
//                     <TableCell><strong>Purpose</strong></TableCell>
//                     <TableCell><strong>Source</strong></TableCell>
//                     <TableCell><strong>View</strong></TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {files.map((file, index) => (
//                     <TableRow key={file.id || index} sx={rowSx}>
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell>{file.uploadedDate}</TableCell>
//                       <TableCell>{file.filename}</TableCell>
//                       <TableCell>{file.purpose}</TableCell>
//                       <TableCell>{file.source}</TableCell>
//                       <TableCell>
//                         <Tooltip title="Open File">
//                           <IconButton color="primary" component="a" href={file.url} target="_blank" rel="noopener noreferrer" size="small">
//                             <OpenInNewIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Delete">
//                           <IconButton color="error" size="small"
//                             onClick={() => fileUpload(file.filename, EMPID, "delete", file.id, file.purpose)}>
//                             <DeleteForeverIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Paper>
//         </Box>
//       )}

//       {/* Occupied Hours Popup */}
//       <OccupiedHrsPopup
//         open={occupiedPopup.open}
//         onClose={() => setOccupiedPopup((prev) => ({ ...prev, open: false }))}
//         employeeName={occupiedPopup.employeeName}
//         employeeRole={occupiedPopup.employeeRole}
//         fromDate={occupiedPopup.fromDate}
//         toDate={occupiedPopup.toDate}
//         occupiedData={occupiedPopup.occupiedData}
//       />

//       {/* Item Type Picker */}
//       <ItemTypePickerDialog
//         open={itemPicker.open}
//         onClose={() => setItemPicker({ open: false, dailyTaskID: null })}
//         onSelect={handleItemTypeSelect}
//       />
//     </React.Fragment>
//   );
// };

// export default EditSprint;

